/* JET Atolye V2 — Wizard ince koprusu
   ============================================
   Mevcut sistem (Fabric canvas, JetAtolye bus, JET_FRAME, JetPhotoLibrary,
   JetSearch, manifest'ler) **dokunulmadan** yeni Casetify-klon DOM'a baglar.
   Yalnizca DOM event -> mevcut API cagrilari yapilir.
*/
(function () {
  'use strict';

  // -- Boot: DOMContentLoaded sonrasi mevcut sistem hazirligini bekle ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Faz 1.3: Entry-point detection (2-katman storage + ?from=direct).
  // Wizard'i yukleyen sayfa; URL'de `?from=direct` varsa veya pathname `/pages/atolye*`/`/pages/customizer*`
  // ise direct entry (kasten gelis); aksi takdirde product entry.
  // Detection wizard DOM init'inden ONCE calismalı çünkü core.js bootDefaultModel
  // sessionStorage entry_source kontrol ediyor (auto-restore defer kararı).
  (function detectEntrySource() {
    try {
      var p = new URLSearchParams(location.search);
      var path = location.pathname || '';
      var fromDirect = p.get('from') === 'direct';
      var pageDirect = /^\/pages\/(atolye|customizer)/i.test(path);
      var fromProduct = path.indexOf('/products/') === 0;
      var src = fromDirect ? 'direct' : (pageDirect ? 'direct' : (fromProduct ? 'product' : 'unknown'));
      sessionStorage.setItem('jetkilif:entry_source', src);
      localStorage.setItem('jetkilif:entry_source', src);
    } catch (e) {}
  })();

  function boot() {
    var root = document.getElementById('jet-wizard');
    if (!root) return;

    // Faz 2.3: jk_active_layout migration. Eski mosaic_*/polaroid/single layout'lar
    // tek-foto implicit sisteminde uyumsuz — clear + kullaniciya toast.
    var __jkMigrationToast = null;
    try {
      var oldLayout = localStorage.getItem('jk_active_layout');
      if (oldLayout && (
        oldLayout.indexOf('mosaic') === 0 ||
        oldLayout.indexOf('mosaic-') === 0 ||
        oldLayout.indexOf('mosaic_') === 0 ||
        oldLayout === 'polaroid'
      )) {
        // QuotaExceededError korumasi
        try { localStorage.removeItem('jk_active_layout'); } catch (e) {}
        __jkMigrationToast = 'Eski tasariminiz yeni tek-foto sistemiyle uyumsuz, sifirlandi.';
      }
    } catch (e) {}

    var state = {
      step: 2,
      // M6: 'bg' | 'stickers' (eski 'templates'/'patterns' deprecated, bg altında sub-tab)
      mode: 'bg',
      // M6: bg sub-tab — 'templates' | 'patterns' | 'solid' | 'picker'
      bgMode: 'templates',
      designSearcher: null,  // Fuse instance
      designItems: [],       // current mode items
      currentCat: 'all',
      productHandle: 'sert-kilif-customizer',
      activeFilter: null,
      // M3: layout = 'single' | 'mosaic-4x9' | 'mosaic-3x7' | 'mosaic-2x6' | 'polaroid' | null
      activeLayout: null,
    };
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.from(root.querySelectorAll(sel)); };

    // Faz H-A2: data-step ID -> DOM-order display num map (DOM yeni sira: 2,3,4,1,5,6)
    // Tanim boot() basinda olmali; openStep(2) line ~94'te cagrilir, var hoisting assignment'i runtime.
    var DISPLAY_NUM = { 2: '01', 3: '02', 4: '03', 1: '04', 5: '05', 6: '06' };

    // M3: localStorage'dan layout cache restore (yoksa null → gate görünür)
    try {
      var savedLayout = localStorage.getItem('jk_active_layout');
      if (savedLayout) state.activeLayout = savedLayout;
    } catch(e) {}

    initAccordion();
    initNav();
    initStep01Design();
    initLayoutGate();        // M3: yeni layout gate
    initStep02Phone();
    initBrandModelCombo();   // Faz 2.1: desktop combobox (UA detect)
    initStep03Product();
    initStep04Photo();
    initStep06Filter();      // M3: artık Step 5 (Düzen kaldırıldı, eski 6 → 5)
    initStep07Text();        // M3: artık Step 6 (eski 7 → 6)
    initBusBindings();
    initPriceAndOffer();     // #16 + #15c (2026-10-03): Sepete Ekle fiyati + "2. kılıf %25" seridi
    initPhotoShortcut(); // Faz H-A4: Tasarim panelinden Foto step'ine yonlendirme
    initStep01PhoneInline(); // Faz H-A3: Step 2 brand+model grid (modal yerine)
    initShellModelButton(); // Faz H-A3: Header 'Telefon Modeli Sec' -> openStep(2)

    openStep(2); // Faz H-A2: Boot Telefon Modeli (yeni 1. step DOM'da, data-step ID sabit)

    // D-09 (2026-09-25): ?from=direct + taslakta iki "devam et" diyalogu ust uste cikiyordu (core + wizard),
    // sonunda model kayboluyordu. Taslak diyalogu artik yalniz core'da (JetAtolye.draftDecision).

    // Faz 2.3: Migration toast — eski mosaic/polaroid layout sifirlandiysa kullaniciya bildir.
    if (__jkMigrationToast && window.JetAtolye && window.JetAtolye.notify) {
      setTimeout(function () {
        window.JetAtolye.notify(__jkMigrationToast, 'warning');
      }, 800);
    }

    // F.6.13 (2026-04-27): Template URL param auto-load
    // /products/...?view=atolye&template=<handle> → wizard otomatik o template'i yükler
    // A4 (2026-09-25): kayitli taslak varken sablon, musteri "Seçtiğim hazır tasarım" diyene kadar yuklenmez
    // ('resume' secilirse hic yuklenmez) — eskiden "Devam et" sonrasi kanvas eski tasarim, state.template yeni kaliyordu.
    function afterDraftDecision(fn) {
      var ja = window.JetAtolye;
      var p = (ja && ja.draftDecision && typeof ja.draftDecision.then === 'function') ? ja.draftDecision : Promise.resolve('none');
      p.then(function (d) { if (d !== 'resume') fn(); });
    }
    function loadTemplateFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        var tplHandle = params.get('template');
        if (!tplHandle) return;
        afterDraftDecision(function () { loadTemplateNow(tplHandle); });
      } catch (e) { console.warn('[TEMPLATE-URL] err', e); }
    }
    function loadTemplateNow(tplHandle) {
      try {
        // designItems yüklenmesini bekle (loadModeData async)
        var attempts = 0;
        var iv = setInterval(function() {
          if (state.designItems && state.designItems.length > 0) {
            clearInterval(iv);
            // Match by id or handle (templates manifest'te id = handle olabilir)
            var match = state.designItems.find(function(it) {
              return it.id === tplHandle || it.handle === tplHandle ||
                     (it.id && it.id.indexOf(tplHandle) >= 0);
            });
            if (match) {
              applyDesignItem(match);
              console.log('[TEMPLATE-URL] auto-loaded:', tplHandle);
            } else {
              console.warn('[TEMPLATE-URL] not found in manifest:', tplHandle);
              // A12 (2026-09-25): olmayan sablon adi sessizce state.template'e yaziliyor, siparise gidiyordu
              if (window.JetAtolye && window.JetAtolye.state && window.JetAtolye.state.template === tplHandle) {
                window.JetAtolye.state.template = null;
              }
              if (window.JetAtolye && window.JetAtolye.notify) {
                window.JetAtolye.notify('Seçtiğin hazır tasarım bulunamadı — listeden başka bir tasarım seçebilir ya da kendi fotoğrafını yükleyebilirsin.', 'warning', { duration: 7000 });
              }
            }
          } else {
            attempts++;
            if (attempts > 30) { clearInterval(iv); console.warn('[TEMPLATE-URL] timeout'); }
          }
        }, 200);
      } catch (e) { console.warn('[TEMPLATE-URL] err', e); }
    }
    setTimeout(loadTemplateFromUrl, 500);  // wizard init sonrası

    // Madde 4 (2026-05-02): URL ?bg=<url> → Fabric.Image olarak canvas'a yükle (foto upload akışı taklit)
    // D-11 (2026-09-25): ?bg= herhangi bir dis (CORS'lu) gorseli "musteri fotografi" olarak yerlestiriyordu,
    // bg=javascript: kirik nesne ekliyordu. Yalniz https + magaza/Shopify CDN/R2 onizleme kaynagi kabul edilir.
    function isAllowedBgUrl(u) {
      try {
        var a = document.createElement('a');
        a.href = u;
        if (a.protocol !== 'https:') return false;
        var h = (a.hostname || '').toLowerCase();
        return h === location.hostname || h === 'jetkilif.com' || h === 'www.jetkilif.com'
          || h === 'cdn.shopify.com' || h === 'holy-surf-0e75jetkilif-preview.yusufardaben.workers.dev';
      } catch (e) { return false; }
    }
    function loadBgFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        var bgUrl = params.get('bg');
        if (!bgUrl) return;
        if (!isAllowedBgUrl(bgUrl)) { console.warn('[BG-URL] izinsiz kaynak, yuklenmedi:', bgUrl); return; }
        afterDraftDecision(function () { loadBgNow(bgUrl); });
      } catch (e) { console.warn('[BG-URL] err', e); }
    }
    function loadBgNow(bgUrl) {
      try {
        var attempts = 0;
        var iv = setInterval(function () {
          var ja = window.JetAtolye;
          var canvas = ja && typeof ja.canvas === 'function' && ja.canvas();
          if (canvas && window.fabric) {
            clearInterval(iv);
            // Önce telefon model seçimi tamamlanmalı (frame yüklenmiş olmalı)
            if (!ja.state || !ja.state.modelConfirmed) {
              // Model seçilince retry
              setTimeout(function () { loadBgNow(bgUrl); }, 1500);
              return;
            }
            window.fabric.Image.fromURL(bgUrl, function (img, isError) {
              if (!img || isError || !img.width) return;
              // Print area: 55,60 → 545,1020 (490×960)
              var pa = { x: 55, y: 60, w: 490, h: 960 };
              var scale = Math.max(pa.w / img.width, pa.h / img.height);
              img.scale(scale);
              img.set({
                left: pa.x + pa.w / 2,
                top: pa.y + pa.h / 2,
                originX: 'center',
                originY: 'center',
                jkUserPhoto: true
              });
              canvas.add(img);
              canvas.sendToBack(img);  // arkaya gönder
              if (canvas.clipPath) {
                img.clipPath = canvas.clipPath;
              }
              canvas.requestRenderAll();
              console.log('[BG-URL] auto-loaded:', bgUrl);
            }, { crossOrigin: 'anonymous' });
          } else {
            attempts++;
            if (attempts > 60) { clearInterval(iv); console.warn('[BG-URL] timeout'); }
          }
        }, 250);
      } catch (e) { console.warn('[BG-URL] err', e); }
    }
    setTimeout(loadBgFromUrl, 800);

    // F.6.7 fix (2026-04-27): Canvas DOM size'ını device wrapper'a fit et
    // Fabric inline style="width:600px" canvas'ı wrapper'dan taşırır (sahne merkez sağ-altta görünür).
    // setDimensions cssOnly:true → DOM render boyut wrapper'a sığar, sahne koordinat 600×1080 korunur.
    function fitCanvasToWrapper() {
      var ja = window.JetAtolye;
      var c = ja && typeof ja.canvas === 'function' && ja.canvas();
      if (!c || !c.lowerCanvasEl) return;
      var wrapper = c.lowerCanvasEl.closest('.jw__device, .ja-canvas-device');
      if (!wrapper) return;
      // F.6.7 fix: Fabric .canvas-container wrapper de 600×1080 → wrapper'dan taşıyor
      // Hedef: container + lower + upper canvas hepsi %100, inline !important
      var container = c.lowerCanvasEl.parentElement; // div.canvas-container
      if (container && container.classList.contains('canvas-container')) {
        container.style.setProperty('width', '100%', 'important');
        container.style.setProperty('height', '100%', 'important');
        container.style.setProperty('position', 'relative', 'important');
      }
      [c.lowerCanvasEl, c.upperCanvasEl].forEach(function(el) {
        if (!el) return;
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('position', 'absolute', 'important');
        el.style.setProperty('top', '0', 'important');
        el.style.setProperty('left', '0', 'important');
      });
      c.requestRenderAll();
      var r = wrapper.getBoundingClientRect();
      console.log('[CANVAS-FIT] DOM size set: wrapper', r.width.toFixed(0) + 'x' + r.height.toFixed(0));
    }
    function startFitPolling() {
      var attempts = 0;
      var iv = setInterval(function () {
        var ja = window.JetAtolye;
        if (ja && typeof ja.canvas === 'function' && ja.canvas() && ja.canvas().lowerCanvasEl) {
          fitCanvasToWrapper();
          attempts++;
          if (attempts >= 3) clearInterval(iv);  // 3x dene (init race için)
        } else {
          attempts++;
          if (attempts > 30) clearInterval(iv);
        }
      }, 200);
    }
    startFitPolling();
    window.addEventListener('resize', fitCanvasToWrapper);
    // Public API
    window.JetWizardFitCanvas = fitCanvasToWrapper;

    // ------------------------------------------------------------------
    function initAccordion() {
      $$('.jw__step-head').forEach(function (head) {
        head.addEventListener('click', function () {
          var step = parseInt(head.parentElement.dataset.step, 10);
          if (root.querySelector('.jw__step.is-open[data-step="' + step + '"]')) {
            closeStep(step);
          } else {
            openStep(step);
          }
        });
      });
      // ESC global
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = root.querySelector('.jw__step.is-open');
        if (open) closeStep(parseInt(open.dataset.step, 10));
      });
    }

    function openStep(n) {
      $$('.jw__step').forEach(function (s) {
        s.classList.toggle('is-open', parseInt(s.dataset.step, 10) === n);
      });
      state.step = n;
      root.dataset.step = String(n);
      var num = $('#jw-step-num');
      if (num) num.textContent = DISPLAY_NUM[n] || String(n).padStart(2, '0');
      // scroll panel'i acik adim'a
      var openEl = root.querySelector('.jw__step.is-open');
      if (openEl) openEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Faz H-A4 + I-4 + I-4.1: Tasarim'dan Foto step'ine yonlendirme (desktop+mobile) + OS file picker auto-open
    function initPhotoShortcut() {
      var btn = root.querySelector('#jw-tasarim-to-photo');
      if (!btn) return;
      btn.addEventListener('click', function () {
        // Desktop: accordion'da Foto step (data-step=4) aç + scroll
        openStep(4);
        var step4 = root.querySelector('.jw__step[data-step="4"]');
        if (step4 && step4.scrollIntoView) {
          setTimeout(function () { step4.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
        }
        // Mobile: bottom sheet engine ile Foto sheet aç (Tasarım sheet kapansın)
        if (window.JetWizardSheet && window.JetWizardSheet.isOpen()) {
          window.JetWizardSheet.close();
          setTimeout(function () { window.JetWizardSheet.open('4', { locked: false }); }, 320);
        }
        // Faz I-4: Auto-open OS file picker (user-gesture chain valid)
        // Sheet transition 320ms + 100ms buffer = 420ms ile file input.click()
        setTimeout(function () {
          var fileInput = document.getElementById('jw-photo-input');
          if (fileInput) fileInput.click();
        }, 500);
      });
    }

    function closeStep(n) {
      var el = root.querySelector('.jw__step[data-step="' + n + '"]');
      if (el) el.classList.remove('is-open');
    }

    function initNav() {
      var prev = root.querySelector('[data-jw-nav="prev"]');
      var next = root.querySelector('[data-jw-nav="next"]');
      if (prev) prev.addEventListener('click', function () {
        openStep(Math.max(1, state.step - 1));
      });
      if (next) next.addEventListener('click', function () {
        openStep(Math.min(7, state.step + 1));
      });
      // Onboarding cue — next butonuna ilk girişte 6sn pulse
      try {
        var seen = localStorage.getItem('jetkilif:wizard_seen_v2');
        if (!seen && next) {
          next.dataset.cue = 'true';
          setTimeout(function () { next.dataset.cue = 'false'; }, 6000);
          localStorage.setItem('jetkilif:wizard_seen_v2', '1');
        }
      } catch (e) {}
    }

    // ------------------------------------------------------------------
    // 01 Tasarim — mode toggle + search + grid (template/sticker/pattern)
    function initStep01Design() {
      // M6: 2-mode toggle (Arka Plan / Sticker)
      $$('.jw__mode-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.jw__mode-btn').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.mode = btn.dataset.mode;
          state.currentCat = 'all';
          // Sub-tabs sadece bg mode'unda görünür
          var subtabs = document.getElementById('jw-bg-subtabs');
          if (subtabs) subtabs.style.display = state.mode === 'bg' ? '' : 'none';
          loadModeData();
        });
      });

      // M6: Arka Plan sub-tabs (templates/patterns/solid/picker)
      $$('#jw-bg-subtabs .jw__bg-tab').forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          // Renk seç sekmesinde input type=color tetikleyecek (e.target color input ise skip)
          if (e.target && e.target.id === 'jw-bg-color-picker') return;
          $$('#jw-bg-subtabs .jw__bg-tab').forEach(function (b) { b.classList.remove('is-active'); });
          tab.classList.add('is-active');
          state.bgMode = tab.dataset.bg;
          state.currentCat = 'all';
          if (state.bgMode === 'picker') {
            // Renk seç tab'ı: native picker'ı aç (programatic click)
            var picker = document.getElementById('jw-bg-color-picker');
            if (picker) picker.click();
            // Grid temizle (picker mode'unda grid göstermiyoruz)
            var grid = $('#jw-design-grid');
            if (grid) grid.innerHTML = '<p style="text-align:center;color:#6B6B6B;padding:1rem;font-size:.85rem">Yukarıdaki renk kutusundan istediğin rengi seç.</p>';
            return;
          }
          loadModeData();
        });
      });

      // M6: Renk seç input handler — bg layer set
      var bgColorInput = document.getElementById('jw-bg-color-picker');
      var bgColorDot = document.getElementById('jw-bg-picker-dot');
      if (bgColorInput) {
        bgColorInput.addEventListener('input', function () {
          var color = bgColorInput.value;
          if (bgColorDot) bgColorDot.style.background = color;
          applyBgColor(color);
        });
      }

      var input = $('#jw-search-design');
      if (input) {
        var deb;
        input.addEventListener('input', function (e) {
          clearTimeout(deb);
          deb = setTimeout(function () {
            renderDesignGrid(e.target.value.trim());
          }, 200);
        });
      }
      loadModeData();
    }

    // M6: Arka plan rengi uygula (renk picker tab'ı) — wizard.js'in solid path'iyle aynı
    function applyBgColor(color) {
      if (!window.JetAtolye || !window.JetAtolye.canvas || !window.fabric) return;
      var c = window.JetAtolye.canvas();
      if (!c) return;
      // v2.2: dinamik print area (model bazli)
      var PA = (window.JetAtolye.getPrintBounds && window.JetAtolye.getPrintBounds())
            || { x: 55, y: 60, w: 490, h: 960, r: 80 };
      if (typeof PA.r !== 'number') PA.r = 80;
      // Önceki bg layer'ı sil
      c.getObjects().filter(function(o){ return o.name === '__jk_bg_layer'; }).forEach(function(o){ c.remove(o); });
      var rect = new window.fabric.Rect({
        left: PA.x, top: PA.y, width: PA.w, height: PA.h,
        rx: PA.r, ry: PA.r,
        fill: color,
        selectable: false, evented: false,
        name: '__jk_bg_layer',
      });
      c.add(rect);
      rect.sendToBack();
      c.requestRenderAll();
      console.log('[BG-PICKER] color:', color);
    }

    function loadModeData() {
      var url, cb;
      // M6: 'bg' mode altında bgMode kontrol; 'stickers' mode aynı
      var effectiveMode = state.mode === 'bg' ? state.bgMode : state.mode;
      if (effectiveMode === 'templates') {
        url = window.JET_ATOLYE_ASSETS && window.JET_ATOLYE_ASSETS.templates;
        cb = function (data) {
          state.designItems = (data && data.templates) || [];
          renderCats((data && data.categories) || [], 'category');
          renderDesignGrid('');
          buildSearcher();
        };
      } else if (effectiveMode === 'stickers') {
        url = window.JET_ATOLYE_ASSETS && window.JET_ATOLYE_ASSETS.stickers;
        cb = function (data) {
          // Nested: data.categories[].stickers[] → flatten
          var cats = (data && data.categories) || [];
          var items = [];
          cats.forEach(function (c) {
            (c.stickers || []).forEach(function (s) {
              items.push({ id: s.id, label: s.label, asset: s.asset, category: c.id, categoryLabel: c.label });
            });
          });
          state.designItems = items;
          renderCats(cats.map(function (c) { return { id: c.id, label: c.label }; }), 'category');
          renderDesignGrid('');
          buildSearcher();
        };
      } else if (effectiveMode === 'solid') {
        // M6: Sadece düz renkler grid (12 swatch)
        var SOLID_COLORS = [
          { id: 'solid-white',    label: 'Beyaz',     color: '#FFFFFF' },
          { id: 'solid-black',    label: 'Siyah',     color: '#1A1A1A' },
          { id: 'solid-cream',    label: 'Krem',      color: '#FAF7F2' },
          { id: 'solid-coral',    label: 'Coral',     color: '#FF6B5D' },
          { id: 'solid-lilac',    label: 'Lila',      color: '#7B61FF' },
          { id: 'solid-mint',     label: 'Nane',      color: '#A6E4D5' },
          { id: 'solid-pink',     label: 'Pembe',     color: '#FFB5C5' },
          { id: 'solid-yellow',   label: 'Sarı',      color: '#FFD66B' },
          { id: 'solid-navy',     label: 'Lacivert',  color: '#1F2A4F' },
          { id: 'solid-forest',   label: 'Orman',     color: '#2D5F4E' },
          { id: 'solid-burgundy', label: 'Bordo',     color: '#7A1D2C' },
          { id: 'solid-gray',     label: 'Gri',       color: '#9B9B9B' },
        ];
        state.designItems = SOLID_COLORS.map(function (s) {
          return { id: s.id, label: s.label, solidColor: s.color, category: 'duz-renk', categoryLabel: 'Düz Renkler' };
        });
        renderCats([], 'category');
        renderDesignGrid('');
        buildSearcher();
        return;
      } else if (effectiveMode === 'patterns') {
        url = window.JET_ATOLYE_ASSETS && window.JET_ATOLYE_ASSETS.patterns;
        cb = function (data) {
          // Nested: data.categories[].patterns[] → flatten (M6: solid renkler ayrı sub-tab'a taşındı)
          var cats = (data && data.categories) || [];
          var items = [];
          cats.forEach(function (c) {
            (c.patterns || []).forEach(function (p) {
              items.push({ id: p.id, label: p.label, asset: p.asset, category: c.id, categoryLabel: c.label });
            });
          });
          state.designItems = items;
          // M6: Düz Renkler artık ayrı sub-tab'da, kategori listesinden kaldırıldı
          renderCats(cats.map(function (c) { return { id: c.id, label: c.label }; }), 'category');
          renderDesignGrid('');
          buildSearcher();
        };
      }
      if (!url) {
        var grid = $('#jw-design-grid');
        if (grid) grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;color:#999;padding:1rem">Manifest URL eksik</div>';
        return;
      }
      fetch(url).then(function (r) { return r.json(); }).then(cb).catch(function () {
        var grid = $('#jw-design-grid');
        if (grid) grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;color:#c33;padding:1rem">İçerik yüklenemedi</div>';
      });
    }

    function buildSearcher() {
      if (window.JetSearch) {
        state.designSearcher = window.JetSearch.create(state.designItems, {
          keys: ['name', 'label', 'category', 'categoryLabel', 'tags', 'id']
        });
      }
    }

    function uniqueCats(items, key) {
      var seen = {};
      var out = [];
      items.forEach(function (it) {
        var c = it[key];
        if (c && !seen[c]) { seen[c] = 1; out.push({ id: c, label: cap(c) }); }
      });
      return out;
    }
    function cap(s) { return String(s).charAt(0).toUpperCase() + String(s).slice(1); }

    // M11 helper: hex bg color → siyah veya beyaz text (WCAG luminance)
    function getContrastColor(hex) {
      if (!hex || typeof hex !== 'string') return '#1A1A1A';
      var c = hex.replace('#', '');
      if (c.length === 3) c = c.split('').map(function(x){return x+x;}).join('');
      var r = parseInt(c.substr(0,2), 16);
      var g = parseInt(c.substr(2,2), 16);
      var b = parseInt(c.substr(4,2), 16);
      var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return lum > 0.55 ? '#1A1A1A' : '#FFFFFF';
    }

    function renderCats(cats, key) {
      var el = $('#jw-cats');
      if (!el) return;
      el.innerHTML = '';
      var all = document.createElement('button');
      all.type = 'button';
      all.dataset.cat = 'all';
      all.className = 'is-active';
      all.textContent = 'Hepsi';
      el.appendChild(all);
      cats.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.cat = c.id;
        b.textContent = c.label;
        el.appendChild(b);
      });
      el.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        $$('#jw-cats button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        state.currentCat = b.dataset.cat;
        renderDesignGrid(($('#jw-search-design') || {}).value || '');
      });
    }

    function renderDesignGrid(query) {
      var grid = $('#jw-design-grid');
      if (!grid) return;
      grid.innerHTML = '';
      var pool = state.designItems.slice();
      if (state.currentCat !== 'all') {
        pool = pool.filter(function (it) { return (it.category || '') === state.currentCat; });
      }
      if (query && state.designSearcher) {
        var hits = state.designSearcher.search(query);
        var hitIds = {};
        hits.forEach(function (h) { hitIds[h.id || h.label] = 1; });
        pool = pool.filter(function (it) { return hitIds[it.id || it.label]; });
      }
      // C8/B-09 (2026-09-30, METIN PAKETI): arama varken siralama tam eslesme -> baslangic -> icerir -> digerleri.
      if (query) {
        var qn = String(query).trim().toLocaleLowerCase('tr');
        var rank = function (it) {
          var n = String(it.name || it.label || '').toLocaleLowerCase('tr');
          return n === qn ? 0 : n.indexOf(qn) === 0 ? 1 : n.indexOf(qn) > 0 ? 2 : 3;
        };
        pool = pool.map(function (it, i) { return { it: it, r: rank(it), i: i }; })
          .sort(function (a, b) { return a.r - b.r || a.i - b.i; }).map(function (x) { return x.it; });
      }
      // M6: effective mode = bg→bgMode, stickers→stickers
      var rdEffectiveMode = state.mode === 'bg' ? state.bgMode : state.mode;
      var renderCard = function (it) {
        var card = document.createElement('div');
        card.className = 'card';
        if (rdEffectiveMode === 'stickers') card.classList.add('is-sticker');
        if (rdEffectiveMode === 'patterns') card.classList.add('is-pattern');
        // F.6.11 fix: solidColor item — img yerine div bg color
        if (it.solidColor) {
          card.classList.add('is-solid-color');
          card.style.backgroundColor = it.solidColor;
          card.style.aspectRatio = '1/1';
          card.style.borderRadius = '8px';
          card.style.border = '1.5px solid rgba(0,0,0,.06)';
          card.title = it.label;
        } else if (rdEffectiveMode === 'templates' && !it.thumbnail && it.fabric) {
          // M11 fallback: thumbnail yok → fabric bg color + label compose card (CSS-only preview)
          card.classList.add('is-template-fallback');
          var bgObj = (it.fabric.objects || []).find(function(o){ return o.name === '__jk_bg_layer'; });
          var bgColor = (bgObj && bgObj.fill) || '#FAF7F2';
          card.style.background = bgColor;
          card.style.display = 'flex';
          card.style.alignItems = 'center';
          card.style.justifyContent = 'center';
          card.style.padding = '8px';
          card.style.textAlign = 'center';
          var lbl = document.createElement('span');
          lbl.textContent = it.name || it.label || '';
          lbl.style.cssText = 'font-size:.75rem; font-weight:700; color:' + getContrastColor(bgColor) + '; line-height:1.2; text-shadow:0 1px 2px rgba(0,0,0,0.15);';
          card.appendChild(lbl);
          card.title = it.name || it.label || '';
        } else {
          var img = document.createElement('img');
          img.loading = 'lazy';
          img.alt = it.name || it.label || it.id || '';
          if (rdEffectiveMode === 'templates') {
            // F3 (Tur 2): preview_image full URL ise direkt kullan; thumbnail asset path ise concat
            if (it.preview_image && /^https?:\/\//.test(it.preview_image)) {
              img.src = it.preview_image;
            } else if (it.thumbnail) {
              img.src = (window.JET_ATOLYE_ASSETS.tplBase || '') + it.thumbnail + '?v=v3';
            } else if (it.preview_image) {
              img.src = (window.JET_ATOLYE_ASSETS.tplBase || '') + it.preview_image + '?v=v3';
            } else if (it.bg_image_url) {
              // R1 (01 rapor): 385 hazir tasarim karti gorselsizdi — Shopify CDN kucultmesiyle (~300 px) goster
              img.src = it.bg_image_url + (it.bg_image_url.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
            }
          } else if (rdEffectiveMode === 'stickers') {
            img.src = (window.JET_ATOLYE_ASSETS.stickerBase || '') + (it.asset || it.file || (it.id + '.png'));
          } else if (rdEffectiveMode === 'patterns') {
            img.src = (window.JET_ATOLYE_ASSETS.patternBase || '') + (it.asset || it.file || (it.id + '.png'));
          }
          card.appendChild(img);
        }
        card.addEventListener('click', function () { applyDesignItem(it); });
        grid.appendChild(card);
      };
      // C8/B-09: ilk 60 + "Daha fazla goster" (60'ar) — 445 sablonun hepsi erisilebilir.
      var shown = Math.min(60, pool.length);
      pool.slice(0, shown).forEach(renderCard);
      var addMoreBtn = function () {
        if (shown >= pool.length) return;
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'jw__more-designs';
        more.style.cssText = 'grid-column:1/-1;margin:8px 0;padding:12px;border:1.5px solid #1A1A1A;border-radius:8px;background:#fff;font-weight:700;cursor:pointer;';
        more.textContent = 'Daha fazla göster (+' + Math.min(60, pool.length - shown) + ')';
        more.addEventListener('click', function () {
          more.remove();
          var next = Math.min(shown + 60, pool.length);
          pool.slice(shown, next).forEach(renderCard);
          shown = next;
          addMoreBtn();
        });
        grid.appendChild(more);
      };
      addMoreBtn();
    }

    // ------------------------------------------------------------------
    // SABLON v2 (2026-10-03): kompozit sablon = foto yuvasi + dekor + duzenlenebilir yazi (kind:"composite").
    // Format: tools/sablon-v2/schema.json. Koordinatlar mutlak kanvas birimi (600x1080) — PA'ya kaydirma YOK.
    // Yuva yer tutucusu: Group {isCollageSlot, jkTplSlot, jkSlotGeom}, secilemez, dokununca foto secimi acilir.
    // Yuvadaki foto: jkSlotIndex + jkTplSlot + yuva sekli clipPath (core model kesimiyle ezmez). Yer tutucu fotonun
    // ALTINDA kalir (foto silinince yuva kendiliginden gorunur); bos yer tutucu baski ciktisina girmez (core _hideTplSlots).
    function whenCanvas(fn) {
      var tries = 0;
      (function tick() {
        var c = window.JetAtolye && window.JetAtolye.canvas && window.JetAtolye.canvas();
        if (c) { fn(c); return; }
        if (++tries < 150) setTimeout(tick, 200);
      })();
    }
    function tplGeom(L) {
      var b = L.box || [0, 0, 100, 100];
      return { shape: L.shape || 'rect', cx: b[0] + b[2] / 2, cy: b[1] + b[3] / 2, w: b[2], h: b[3], angle: L.angle || 0, rx: L.rx };
    }
    function tplShapePath(shape, w, h) {
      if (shape === 'heart') {
        var sx = w / 100, sy = h / 100;
        var P = function (x, y) { return (x * sx).toFixed(2) + ',' + (y * sy).toFixed(2); };
        return 'M ' + P(50, 100) + ' C ' + P(22, 80) + ' ' + P(0, 58) + ' ' + P(0, 31) + ' C ' + P(0, 13) + ' ' + P(13, 0) + ' ' + P(29, 0)
          + ' C ' + P(39, 0) + ' ' + P(46, 6) + ' ' + P(50, 15) + ' C ' + P(54, 6) + ' ' + P(61, 0) + ' ' + P(71, 0)
          + ' C ' + P(87, 0) + ' ' + P(100, 13) + ' ' + P(100, 31) + ' C ' + P(100, 58) + ' ' + P(78, 80) + ' ' + P(50, 100) + ' Z';
      }
      // arch: ustu yarim daire kemer
      var r = Math.min(w / 2, h);
      return 'M 0,' + h + ' L 0,' + r + ' A ' + r + ',' + r + ' 0 0 1 ' + w + ',' + r + ' L ' + w + ',' + h + ' Z';
    }
    function tplMakeShape(g, extra) {
      var F = window.fabric, o;
      var base = { originX: 'center', originY: 'center', left: g.cx, top: g.cy, angle: g.angle || 0 };
      if (g.shape === 'circle') {
        o = new F.Ellipse(Object.assign({ rx: g.w / 2, ry: g.h / 2 }, base));
      } else if (g.shape === 'heart' || g.shape === 'arch') {
        o = new F.Path(tplShapePath(g.shape, g.w, g.h), base);
      } else {
        var r = g.shape === 'rounded' ? (g.rx != null ? g.rx : Math.round(Math.min(g.w, g.h) * 0.12)) : (g.rx || 0);
        o = new F.Rect(Object.assign({ width: g.w, height: g.h, rx: r, ry: r }, base));
      }
      if (extra) o.set(extra);
      return o;
    }
    function tplMakeSlot(L, idx) {
      var F = window.fabric, g = tplGeom(L);
      var col = L.placeholderColor || 'rgba(26,26,26,0.55)';
      var loc = Object.assign({}, g, { cx: 0, cy: 0, angle: 0 });
      var pad = 7;
      var parts = [
        tplMakeShape(loc, { fill: L.placeholderFill || 'rgba(255,255,255,0.6)' }),
        tplMakeShape(Object.assign({}, loc, { w: g.w - 2 * pad, h: g.h - 2 * pad, rx: g.rx != null ? Math.max(0, g.rx - pad) : g.rx }),
          { fill: '', stroke: col, strokeWidth: 2, strokeDashArray: [7, 6] }),
      ];
      var fs = Math.max(12, Math.min(18, Math.round(Math.min(g.w, g.h) * 0.085)));
      var cy = g.shape === 'heart' ? -g.h * 0.06 : -fs * 0.7;
      parts.push(new F.Circle({ radius: fs * 1.25, originX: 'center', originY: 'center', left: 0, top: cy, fill: 'rgba(255,255,255,0.92)', stroke: col, strokeWidth: 2 }));
      parts.push(new F.Path('M ' + (-fs * 0.6) + ',0 L ' + (fs * 0.6) + ',0 M 0,' + (-fs * 0.6) + ' L 0,' + (fs * 0.6),
        { originX: 'center', originY: 'center', left: 0, top: cy, fill: '', stroke: col, strokeWidth: 3, strokeLineCap: 'round' }));
      parts.push(new F.Text(L.placeholder || 'Fotoğraf ekle', { originX: 'center', originY: 'center', left: 0, top: cy + fs * 2.3,
        fontFamily: 'Montserrat', fontWeight: 700, fontSize: fs, fill: col }));
      return new F.Group(parts, {
        originX: 'center', originY: 'center', left: g.cx, top: g.cy, angle: g.angle || 0,
        name: '__jk_tpl_slot', isCollageSlot: true, slotIndex: idx, slotEmpty: true, slotShape: g.shape,
        jkTplSlot: L.id, jkSlotGeom: JSON.stringify(g), selectable: false, evented: true, hoverCursor: 'pointer',
      });
    }
    function tplDecorProps(L) {
      return {
        name: '__jk_tpl_decor', selectable: false, evented: false,
        fill: L.fill == null ? '' : L.fill, stroke: L.stroke || null, strokeWidth: L.strokeWidth || 0,
        strokeLineCap: L.lineCap || 'round', strokeLineJoin: 'round', strokeDashArray: L.dash || null,
        opacity: L.opacity == null ? 1 : L.opacity,
        shadow: L.shadow ? new window.fabric.Shadow(L.shadow) : null,
      };
    }
    function tplFitText(t) {
      if (!t || !t.jkTplMaxW) return;
      try { t.initDimensions(); } catch (e) { /* ignore */ }
      var s = Math.min(1, t.jkTplMaxW / (t.width || 1));
      t.set({ scaleX: s, scaleY: s });
      t.setCoords();
    }
    function tplGetSlots(c) {
      var objs = c.getObjects();
      var slots = objs.filter(function (o) { return o && o.isCollageSlot && o.jkTplSlot; });
      slots.forEach(function (ph) {
        ph.slotEmpty = !objs.some(function (o) { return o && o.type === 'image' && o.jkTplSlot === ph.jkTplSlot && !o.isCollageSlot; });
      });
      return slots;
    }
    function tplOccupant(c, ph) {
      return c.getObjects().filter(function (o) { return o && o.type === 'image' && !o.isCollageSlot && o.jkTplSlot === ph.jkTplSlot; })[0] || null;
    }
    function tplFindSlot(c, id) {
      return tplGetSlots(c).filter(function (s) { return s.jkTplSlot === id; })[0] || null;
    }
    // Fotoyu yuvaya yerlestir: yuvayi kaplar (cover), yuva acisi, yuva sekli kesim, yer tutucunun hemen USTUNE (dekor/yazi ustte kalir)
    function tplPlacePhoto(c, im, ph) {
      var g = JSON.parse(ph.jkSlotGeom);
      var iw = im.width || 1, ih = im.height || 1;
      var sc = Math.max(g.w / iw, g.h / ih);
      if (c.getObjects().indexOf(im) >= 0) c.remove(im);
      im.set({
        left: g.cx, top: g.cy, originX: 'center', originY: 'center', scaleX: sc, scaleY: sc, angle: g.angle || 0,
        jkSlotIndex: ph.slotIndex, jkTplSlot: ph.jkTplSlot,
        clipPath: tplMakeShape(g, { absolutePositioned: true }),
        lockRotation: true, lockUniScaling: true, lockScalingX: false, lockScalingY: false, hasControls: true,
      });
      if (typeof im.setControlsVisibility === 'function') im.setControlsVisibility({ mtr: false });
      c.insertAt(im, c.getObjects().indexOf(ph) + 1);
      ph.slotEmpty = false;
      im.setCoords();
      return sc;
    }
    function tplIsPhoto(o) {
      return !!(o && o.type === 'image' && o.name !== '__jk_bg_layer' && o.name !== '__jk_tpl_decor'
        && (o.jkPhotoId || String((o.getSrc && o.getSrc()) || '').indexOf('data:') === 0));
    }
    // Kompozite gecerken onay yalniz serbest yazi/cikartma kaybolacaksa sorulur (fotolar yuvaya gecer, sablon yazilari tasinir)
    function tplHasLosableContent(c) {
      return c.getObjects().some(function (o) {
        if (!o || o.name === '__jk_bg_layer' || o.name === '__jk_safezone_guide' || o.name === '__jk_tpl_decor' || o.isCollageSlot) return false;
        if (tplIsPhoto(o) || o.jkTplText) return false;
        return o.type === 'image' || o.type === 'i-text' || o.type === 'textbox' || o.type === 'text' || o.type === 'group';
      });
    }
    function tplLoadImage(src) {
      return new Promise(function (res) {
        window.fabric.Image.fromURL(src, function (im, err) { res(im && !err && im.width ? im : null); }, { crossOrigin: 'anonymous' });
      });
    }
    function tplFontsReady(spec) {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      var want = { '700 20px "Montserrat"': 1 };
      (spec.layers || []).forEach(function (L) {
        if (L.role === 'text') want[(L.weight || 400) + ' 40px "' + (L.font || 'Inter') + '"'] = 1;
      });
      var ps = Object.keys(want).map(function (f) { return document.fonts.load(f, 'AaĞğÜüŞşİıÖöÇç&0').catch(function () {}); });
      return Promise.race([Promise.all(ps), new Promise(function (r) { setTimeout(r, 3500); })]);
    }
    function tplBgFill(L) {
      if (L.type !== 'gradient' || !L.stops) return L.fill || '#FFFFFF';
      var a = (L.angle == null ? 180 : L.angle) * Math.PI / 180;
      var dx = Math.sin(a), dy = -Math.cos(a), len = Math.abs(300 * dx) + Math.abs(540 * dy);
      return new window.fabric.Gradient({
        type: 'linear', gradientUnits: 'pixels',
        coords: { x1: 300 - dx * len, y1: 540 - dy * len, x2: 300 + dx * len, y2: 540 + dy * len },
        colorStops: L.stops.map(function (s) { return { offset: s[0], color: s[1] }; }),
      });
    }
    function applyComposite(it) {
      var ja = window.JetAtolye, F = window.fabric;
      var c = ja && ja.canvas && ja.canvas();
      if (!c || !F || !it || !it.spec || !it.spec.layers) return Promise.resolve(false);
      var spec = it.spec;
      state.pendingSlot = null;
      // 1) Mevcut fotolar SILINMEZ: once eski yuva sirasi, sonra kanvas z-sirasi (yukleme sirasi)
      var objs = c.getObjects();
      var photos = objs.filter(tplIsPhoto).map(function (o, i) { return { o: o, k: o.jkSlotIndex != null ? o.jkSlotIndex : 1000 + i }; })
        .sort(function (a, b) { return a.k - b.k; }).map(function (x) { return x.o; });
      var onCanvas = {};
      photos.forEach(function (p) { if (p.jkPhotoId) onCanvas[p.jkPhotoId] = 1; });
      // Sablon yazisi tasima: ayni id'li yazi (or. "isim", "tarih") musteri degistirdiyse yeni sablona gecer
      var carry = {};
      objs.forEach(function (o) {
        if (o && o.jkTplText && typeof o.text === 'string' && o.text !== o._jkTplDefault) carry[o.jkTplText] = o.text;
      });
      var slotCount = spec.layers.filter(function (L) { return L.role === 'slot'; }).length;
      var lib = (window.JetPhotoLibrary && window.JetPhotoLibrary.list && window.JetPhotoLibrary.list()) || [];
      var fromLib = lib.filter(function (p) { return p && p.id && !onCanvas[p.id]; }).slice(0, Math.max(0, slotCount - photos.length));
      var imgSrcs = spec.layers.filter(function (L) { return (L.role === 'bg' || L.role === 'decor') && L.type === 'image' && L.src; });
      return Promise.all([
        tplFontsReady(spec),
        Promise.all(fromLib.map(function (p) {
          return tplLoadImage(p.dataUrl).then(function (im) { if (im) im.jkPhotoId = p.id; return im; });
        })),
        Promise.all(imgSrcs.map(function (L) { return tplLoadImage(L.src); })),
      ]).then(function (r) {
        try { F.util.clearFabricFontCache(); } catch (e) { /* ignore */ }
        photos = photos.concat(r[1].filter(Boolean));
        var imgBy = new Map();
        imgSrcs.forEach(function (L, i) { imgBy.set(L, r[2][i]); });
        var built = [], slots = [];
        spec.layers.forEach(function (L) {
          var o = null;
          if (L.role === 'bg') {
            var im = imgBy.get(L);
            if (L.type === 'image' && im) {
              var s = Math.max(600 / im.width, 1080 / im.height);
              o = im.set({ left: 300, top: 540, originX: 'center', originY: 'center', scaleX: s, scaleY: s });
            } else {
              o = new F.Rect({ left: 0, top: 0, width: 600, height: 1080, fill: tplBgFill(L) });
            }
            o.set({ name: '__jk_bg_layer', selectable: false, evented: false });
          } else if (L.role === 'decor') {
            if (L.type === 'path' && L.d) o = new F.Path(L.d, tplDecorProps(L));
            else if (L.type === 'shape') o = tplMakeShape(tplGeom(L), tplDecorProps(L));
            else if (L.type === 'image' && imgBy.get(L)) {
              var di = imgBy.get(L), g = tplGeom(L);
              o = di.set(Object.assign(tplDecorProps(L), { fill: null, left: g.cx, top: g.cy, originX: 'center', originY: 'center',
                angle: g.angle, scaleX: g.w / di.width, scaleY: g.h / di.height }));
            }
          } else if (L.role === 'slot') {
            o = tplMakeSlot(L, slots.length);
            slots.push(o);
            built.push(o);
            if (L.frame) {   // yuva cercevesi: foto bunun ALTINA girer
              var fg = tplGeom(L), off = L.frame.offset || 0;
              fg.w += 2 * off; fg.h += 2 * off;
              if (fg.rx != null) fg.rx += off;
              o = tplMakeShape(fg, Object.assign(tplDecorProps({ stroke: L.frame.color || '#FFFFFF', strokeWidth: L.frame.width || 6 }), { fill: '' }));
            } else {
              o = null;
            }
          } else if (L.role === 'text') {
            var ed = L.editable !== false;
            o = new F.IText(String(carry[L.id] != null ? carry[L.id] : (L.text || '')), {
              originX: 'center', originY: 'center', left: L.center[0], top: L.center[1], angle: L.angle || 0,
              fontFamily: L.font || 'Inter', fontWeight: L.weight || 400, fontStyle: L.italic ? 'italic' : 'normal',
              fontSize: L.size || 40, fill: L.fill || '#1A1A1A', textAlign: L.align || 'center',
              charSpacing: L.charSpacing || 0, lineHeight: L.lineHeight || 1.16, styles: {},
              stroke: L.stroke || null, strokeWidth: L.strokeWidth || 0,
              jkTplText: L.id, jkTplMaxW: L.maxWidth || 420, jkTplMaxChars: L.maxChars || 40,
              editable: ed, selectable: ed, evented: ed,
            });
            o._jkTplDefault = L.text || '';
            tplFitText(o);
          }
          if (o) built.push(o);
        });
        var extra = Math.max(0, photos.length - slots.length);
        var build = function () {
          c.discardActiveObject();
          c.getObjects().slice().forEach(function (o) { if (o && o.name !== '__jk_safezone_guide') c.remove(o); });
          built.forEach(function (o) { c.add(o); });
          c.getObjects().filter(function (o) { return o.name === '__jk_safezone_guide'; }).forEach(function (g) { c.bringToFront(g); });
          for (var k = 0; k < Math.min(slots.length, photos.length); k++) tplPlacePhoto(c, photos[k], slots[k]);
        };
        if (ja.undoBatch) ja.undoBatch(build); else build();
        if (ja.state) ja.state.template = it.id;
        try { state.lastTemplateSig = sigOf(c); } catch (eSig) { state.lastTemplateSig = null; }
        c.requestRenderAll();
        if (window.JetWizardSheet && window.JetWizardSheet.isOpen && window.JetWizardSheet.isOpen()) window.JetWizardSheet.close();
        if (ja.notify) {
          var empty = tplGetSlots(c).filter(function (s) { return s.slotEmpty; }).length;
          if (empty) ja.notify('Şablon hazır — boş yuvaya dokunup fotoğrafını ekle.', 'info', { duration: 6000 });
          else if (extra) ja.notify(extra + ' fotoğrafın yuvalara sığmadı; fotoğraflarında duruyor, istersen yuvadakiyle değiştirebilirsin.', 'info', { duration: 7000 });
        }
        console.log('[TEMPLATE-V2] applied:', it.id, 'slots:', slots.length, 'photos:', Math.min(slots.length, photos.length));
        return true;
      });
    }
    window.JetTplComposite = { version: 1, apply: function (it) { return applyComposite(it); }, slots: function () {
      var c = window.JetAtolye && window.JetAtolye.canvas && window.JetAtolye.canvas();
      return c ? tplGetSlots(c) : [];
    } };

    // B-08 (2026-09-25): foto/yazi/sticker varken hazir tasarim karti onay sormadan her seyi siliyordu (c.clear()).
    function canvasHasUserContent(c) {
      return c.getObjects().some(function (o) {
        if (!o || o.name === '__jk_bg_layer' || o.name === '__jk_safezone_guide' || o.isCollageSlot) return false;
        return o.type === 'image' || o.type === 'i-text' || o.type === 'textbox' || o.type === 'text' || o.type === 'group';
      });
    }
    // C2/B-08 (2026-09-30): sablon -> sablon gecisinde gereksiz onay. Uygulanan sablonun imzasi saklanir;
    // kanvas o imzayla birebir ayniysa (kullanici hicbir sey degistirmediyse) onay sorulmaz.
    // Imza: renk/font/aci/olcek/konum/metin dahil (yalniz uzunluk/konum YETMEZ). djb2 = esitlik icin, guvenlik degil.
    function sigOf(c) {
      var parts = c.getObjects().filter(function (o) {
        return o && o.name !== '__jk_bg_layer' && o.name !== '__jk_safezone_guide';
      }).map(function (o) {
        var src = (o.getSrc && o.getSrc()) || o.src || '';
        return [o.type, o.name || '', o.text || '', o.fill || '', o.stroke || '', o.fontFamily || '', o.fontSize || '',
          o.fontWeight || '', o.fontStyle || '', Math.round((o.left || 0) * 10), Math.round((o.top || 0) * 10),
          Math.round((o.angle || 0) * 100), Math.round((o.scaleX || 1) * 1000), Math.round((o.scaleY || 1) * 1000),
          o.flipX ? 1 : 0, o.flipY ? 1 : 0, o.opacity, o.jkPhotoId || '', String(src).length, String(src).slice(-64)].join('');
      }).join('');
      var h = 5381;
      for (var i = 0; i < parts.length; i++) h = ((h << 5) + h + parts.charCodeAt(i)) | 0;
      return parts.length + ':' + h;
    }
    function applyDesignItem(it, confirmed) {
      var ja = window.JetAtolye;
      if (!ja || !ja.canvas) return;
      var c = ja.canvas();
      if (!c) return;
      var modeNow = state.mode === 'bg' ? state.bgMode : state.mode;
      var untouchedTpl = !!state.lastTemplateSig && sigOf(c) === state.lastTemplateSig;
      // Sablon v2: kompozit sablon fotolari silmez (yuvalara yerlestirir) -> onay yalniz serbest yazi/cikartma icin
      var isComposite = !!(it && it.kind === 'composite' && it.spec);
      var losable = isComposite ? tplHasLosableContent(c) : canvasHasUserContent(c);
      if (!confirmed && modeNow === 'templates' && losable && !untouchedTpl && ja.confirmInline) {
        ja.confirmInline({
          title: 'Hazır tasarım uygulansın mı?',
          body: isComposite
            ? 'Fotoğrafların şablondaki yuvalara yerleşecek; eklediğin yazı ve çıkartmalar bu şablonla değişecek.'
            : 'Bu hazır tasarım, kanvastaki fotoğraf ve yazılarının yerine geçecek.',
          ok: 'Evet, uygula',
          cancel: 'Vazgeç',
        }).then(function (yes) { if (yes) applyDesignItem(it, true); });
        return;
      }
      if (isComposite && modeNow === 'templates') { applyComposite(it); return; }
      // F.6.6 fix (2026-04-27): viewport-aware center + clipPath + bg layer Rect
      // v2.2: Dinamik print area (model bazli clipPath bbox), fallback eski sabit PA.
      var PA = (window.JetAtolye && window.JetAtolye.getPrintBounds && window.JetAtolye.getPrintBounds())
            || { x: 55, y: 60, w: 490, h: 960, r: 80, cx: 300, cy: 540 };
      if (typeof PA.cx !== 'number') PA.cx = PA.x + PA.w / 2;
      if (typeof PA.cy !== 'number') PA.cy = PA.y + PA.h / 2;
      if (typeof PA.r !== 'number') PA.r = 80;
      function viewportCenter(obj) {
        if (typeof c.viewportCenterObject === 'function') {
          c.viewportCenterObject(obj);
        } else {
          var vpt = c.viewportTransform || [1,0,0,1,0,0];
          obj.set({
            left: (c.width / 2 - vpt[4]) / vpt[0],
            top:  (c.height / 2 - vpt[5]) / vpt[3]
          });
        }
        obj.setCoords();
      }
      // M6: effective mode = bg→bgMode, stickers→stickers
      var effectiveMode = state.mode === 'bg' ? state.bgMode : state.mode;
      if (effectiveMode === 'templates' && it.bg_image_url && !it.fabric) {
        // F3 (Tur 2): JK Studio template — background image apply
        c.clear();
        if (window.fabric && window.fabric.Image) {
          window.fabric.Image.fromURL(it.bg_image_url, function (img) {
            if (!img) { console.error('[TEMPLATE-BG] decode failed:', it.bg_image_url); return; }
            // PA'ya cover-fit
            var sx = PA.w / img.width;
            var sy = PA.h / img.height;
            var sc = Math.max(sx, sy);
            img.set({
              left: PA.x + PA.w/2,
              top: PA.y + PA.h/2,
              originX: 'center', originY: 'center',
              scaleX: sc, scaleY: sc,
              selectable: false, evented: false,
              name: '__jk_bg_layer',
              clipPath: new window.fabric.Rect({
                left: PA.x, top: PA.y, width: PA.w, height: PA.h,
                rx: PA.r, ry: PA.r,
                absolutePositioned: true,
              }),
            });
            c.add(img);
            c.sendToBack(img);
            c.requestRenderAll();
            if (ja.state) ja.state.template = it.id;   // Sablon v2: grid secimi de olculsun (_TemplateId)
            console.log('[TEMPLATE-BG] applied:', it.id, it.bg_image_url);
          }, { crossOrigin: 'anonymous' });
        }
        return;
      }
      if (effectiveMode === 'templates' && it.fabric) {
        c.clear();
        // M11: STICKER_BASE_PLACEHOLDER → runtime stickerBase URL replace
        var fabricSpec = it.fabric;
        if (fabricSpec && fabricSpec.objects) {
          var sBase = window.JET_ATOLYE_ASSETS && window.JET_ATOLYE_ASSETS.stickerBase;
          if (sBase) {
            // Deep-clone obj'leri (mutate etmeyelim manifest'i)
            fabricSpec = JSON.parse(JSON.stringify(it.fabric));
            fabricSpec.objects.forEach(function (o) {
              if (o.src && typeof o.src === 'string') {
                o.src = o.src.replace(/^STICKER_BASE_PLACEHOLDER\//, sBase);
              }
            });
          }
        }
        c.loadFromJSON(fabricSpec, function () {
          // v2.3: Template orijinal boyutta apply (kullanici kucultme istemedi).
          // Sadece TRANSLATE: template merkezini print area merkezine kaydir.
          // Tasan kisim canvas.clipPath ile zaten otomatik kesilir.
          var objs = c.getObjects();
          if (objs.length > 0) {
            var minX=Infinity, minY=Infinity, maxX=-Infinity, maxY=-Infinity;
            objs.forEach(function(o){
              var b = o.getBoundingRect(true);
              if (b.left < minX) minX = b.left;
              if (b.top < minY) minY = b.top;
              if (b.left+b.width > maxX) maxX = b.left+b.width;
              if (b.top+b.height > maxY) maxY = b.top+b.height;
            });
            var tplCx = (minX + maxX) / 2;
            var tplCy = (minY + maxY) / 2;
            var dx = PA.cx - tplCx;
            var dy = PA.cy - tplCy;
            objs.forEach(function(o){
              o.left = (o.left || 0) + dx;
              o.top = (o.top || 0) + dy;
              o.setCoords();
            });
          }
          c.requestRenderAll();
          try { state.lastTemplateSig = sigOf(c); } catch (eSig) { state.lastTemplateSig = null; }
          if (ja.state) ja.state.template = it.id;   // Sablon v2: grid secimi de olculsun (_TemplateId)
          console.log('[TEMPLATE] applied:', it.id, 'objs:', objs.length, '(no-scale, translate only)');
        });
      } else if (effectiveMode === 'stickers') {
        var url = (window.JET_ATOLYE_ASSETS.stickerBase || '') + (it.asset || it.file || (it.id + '.png'));
        if (window.fabric && window.fabric.Image) {
          window.fabric.Image.fromURL(url, function (im) {
            if (!im) { console.error('[STICKER] decode failed:', url); return; }
            im.scaleToWidth(180);
            im.set({
              originX: 'center', originY: 'center',
              // F.6.6 Sticker fix: print area clipPath ekle
              clipPath: new window.fabric.Rect({
                left: PA.x, top: PA.y, width: PA.w, height: PA.h,
                rx: PA.r, ry: PA.r,
                absolutePositioned: true,
              }),
            });
            c.add(im);
            viewportCenter(im);  // viewport-aware center
            c.setActiveObject(im);
            c.requestRenderAll();
            console.log('[STICKER] added:', url);
          }, { crossOrigin: 'anonymous' });
        }
      } else if (effectiveMode === 'patterns' || effectiveMode === 'solid') {
        // F.6.11 fix: solidColor (düz renk) için ayrı path — image yüklenmesini beklemez
        // M6: solid mode'unda items hep solidColor; patterns mode'unda asset URL
        if (it.solidColor) {
          c.getObjects().filter(function(o){ return o.name === '__jk_bg_layer'; }).forEach(function(o){ c.remove(o); });
          var solidRect = new window.fabric.Rect({
            left: PA.x, top: PA.y, width: PA.w, height: PA.h,
            rx: PA.r, ry: PA.r,
            fill: it.solidColor,
            selectable: false, evented: false,
            name: '__jk_bg_layer',
          });
          c.add(solidRect);
          solidRect.sendToBack();
          c.requestRenderAll();
          console.log('[BG-COLOR] solid:', it.solidColor, '(' + it.label + ')');
          return;
        }
        var pUrl = (window.JET_ATOLYE_ASSETS.patternBase || '') + (it.asset || it.file || (it.id + '.png'));
        // v2.8.3 (kullanici raporlu: desenler duzgun yerlesmiyor):
        // gradient/marble kategorileri 200x200 image olarak repeat tile edildiginde
        // 5-6 yatay tekrar bandı olusuyor — yumusak gecis kayboluyor. Bu kategoriler
        // tek seferde STRETCH edilmeli (image olarak BG layer). Diger kategoriler
        // (geometric/dama/turk/floral/doku) tile-friendly, repeat'e devam.
        var category = (it.id || '').split('-')[0];
        var STRETCH_CATEGORIES = ['gradient', 'marble'];
        var shouldStretch = STRETCH_CATEGORIES.indexOf(category) >= 0;

        if (shouldStretch) {
          window.fabric.Image.fromURL(pUrl, function (img) {
            if (!img) { console.error('[PATTERN-STRETCH] decode failed:', pUrl); return; }
            // PA boyutuna stretch (cover değil exact fit)
            img.set({
              left: PA.x, top: PA.y, originX: 'left', originY: 'top',
              scaleX: PA.w / (img.width || 1),
              scaleY: PA.h / (img.height || 1),
              selectable: false, evented: false, name: '__jk_bg_layer',
            });
            c.getObjects().filter(function(o){ return o.name === '__jk_bg_layer'; }).forEach(function(o){ c.remove(o); });
            c.add(img);
            img.sendToBack();
            c.requestRenderAll();
            console.log('[PATTERN-STRETCH]', category, 'applied:', pUrl);
          }, { crossOrigin: 'anonymous' });
        } else {
          var imgEl = new Image();
          imgEl.crossOrigin = 'anonymous';
          imgEl.onload = function () {
            var pat = new window.fabric.Pattern({ source: imgEl, repeat: 'repeat' });
            c.getObjects().filter(function(o){ return o.name === '__jk_bg_layer'; }).forEach(function(o){ c.remove(o); });
            var rect = new window.fabric.Rect({
              left: PA.x, top: PA.y, width: PA.w, height: PA.h,
              rx: PA.r, ry: PA.r,
              fill: pat,
              selectable: false, evented: false,
              name: '__jk_bg_layer',
            });
            c.add(rect);
            rect.sendToBack();
            c.requestRenderAll();
            console.log('[PATTERN-TILE]', category, 'applied:', pUrl);
          };
          imgEl.src = pUrl;
        }
      }
    }


    // ------------------------------------------------------------------
    // Faz H-A3: Step 2 inline brand+model grid (modal yerine)
    // - JET_FRAME.MODELS data ile dinamik kart grid
    // - Stok toggle (default: only inStock)
    // - Brand kart click -> model grid populate, brand select sync
    // - Model kart click -> JetAtolye.setModel + jw-brand/jw-model select sync
    function initStep01PhoneInline() {
      var brandsWrap = $('#jw-brands-inline');
      var modelsWrap = $('#jw-models-inline');
      var brandSection = $('#jw-brand-section');
      var modelSection = $('#jw-model-section');
      var stockToggle = $('#jw-stock-toggle-inline');
      var backBtn = $('#jw-brand-back');
      var backLabel = $('#jw-brand-back-label');
      if (!brandsWrap || !modelsWrap || !brandSection || !modelSection) return;

      var _currentBrand = null;

      function renderBrands() {
        if (!window.JET_FRAME || !window.JET_FRAME.getBrands) return false;
        brandsWrap.innerHTML = '';
        window.JET_FRAME.getBrands().forEach(function (brand) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'jw__brand-card';
          btn.dataset.brand = brand;
          btn.textContent = brand;
          btn.addEventListener('click', function () { showModels(brand); });
          brandsWrap.appendChild(btn);
        });
        return true;
      }

      function showModels(brand) {
        if (!window.JET_FRAME || !window.JET_FRAME.getModels) return;
        _currentBrand = brand;
        if (backLabel) backLabel.textContent = brand + ' \u2014 Marka degistir';
        renderModelGrid();
        brandSection.hidden = true;
        modelSection.hidden = false;
        // scroll to top of step body for visibility
        var step = root.querySelector('.jw__step[data-step="2"] .jw__step-body');
        if (step && step.scrollIntoView) step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function renderModelGrid() {
        if (!_currentBrand) return;
        var onlyInStock = !stockToggle || stockToggle.checked;
        modelsWrap.innerHTML = '';
        var models = window.JET_FRAME.getModels(_currentBrand, { onlyInStock: false });
        if (onlyInStock) {
          models = models.filter(function (m) { return m.inStock; });
        }
        if (!models.length) {
          var empty = document.createElement('p');
          empty.style.cssText = 'color:#999;text-align:center;padding:1rem;font-size:.85rem;grid-column:1/-1';
          empty.textContent = onlyInStock
            ? 'Bu markada stoktaki model yok. Tum modelleri goster icin uste isaretle.'
            : 'Model listesi bos.';
          modelsWrap.appendChild(empty);
          return;
        }
        models.forEach(function (m) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'jw__model-card' + (m.inStock ? '' : ' no-stock');
          btn.dataset.brand = _currentBrand;
          btn.dataset.model = m.name;
          btn.dataset.slug = m.slug;
          var name = document.createElement('span');
          name.textContent = m.name;
          btn.appendChild(name);
          if (!m.inStock) {
            var b1 = document.createElement('span');
            b1.className = 'badge no-stock';
            b1.textContent = 'Stokta yok';
            btn.appendChild(b1);
          } else if (m.note) {
            var b3 = document.createElement('span');
            b3.className = 'badge model-note';
            b3.textContent = m.note;
            btn.appendChild(b3);
          } else if (!m.hasFrame) {
            var b2 = document.createElement('span');
            b2.className = 'badge no-frame';
            b2.textContent = 'Genel onizleme';
            btn.appendChild(b2);
          }
          btn.addEventListener('click', function () {
            if (!m.inStock) {
              if (window.JetAtolye && window.JetAtolye.notify) {
                window.JetAtolye.notify('Bu model su anda stokta degil', 'warning');
              }
              return;
            }
            // Highlight selected
            modelsWrap.querySelectorAll('.jw__model-card.is-selected').forEach(function (n) { n.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            // Sync legacy native select-row (Faz 2.1 combobox / iOS fallback)
            if (typeof window.__jwSyncFromCombo === 'function') {
              window.__jwSyncFromCombo(_currentBrand, m.slug, m.name);
            } else if (window.JetAtolye && window.JetAtolye.setModel) {
              window.JetAtolye.setModel(_currentBrand, m.name);
            }
            // Faz I-2: Auto-advance Step 1 -> Step 2 (Kılıf Tipi, data-step="3")
            // Edge: hasDesign varsa setModel confirm modal tetikler — auto-advance SKIP
            var hasDesign = false;
            try {
              var c = window.JetAtolye && window.JetAtolye.canvas && window.JetAtolye.canvas();
              if (c) hasDesign = c.getObjects().some(function (o) {
                if (!o || o.name === '__jk_bg_layer') return false;
                return !!o.jkPhotoId || o.type === 'i-text' || o.type === 'textbox' || o.kind === 'sticker' || o.kind === 'template';
              });
            } catch (e) {}
            if (!hasDesign) {
              setTimeout(function () {
                // Desktop: accordion'da Step 2 (data-step=3) aç
                openStep(3);
                var step3 = root.querySelector('.jw__step[data-step="3"]');
                if (step3 && step3.scrollIntoView) {
                  step3.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                // Mobile: bottom sheet engine ile Step 2 (Kılıf Tipi) aç
                // wizard.liquid:1750 JetWizardSheet API — closeSheet + open('3')
                if (window.JetWizardSheet && window.JetWizardSheet.isOpen()) {
                  window.JetWizardSheet.close();
                  setTimeout(function () { window.JetWizardSheet.open('3', { locked: false }); }, 320);
                }
              }, 250);
            }
          });
          modelsWrap.appendChild(btn);
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          modelSection.hidden = true;
          brandSection.hidden = false;
        });
      }
      if (stockToggle) {
        stockToggle.addEventListener('change', renderModelGrid);
      }

      // Initial render — JET_FRAME may load async, retry pattern
      if (!renderBrands()) {
        var attempts = 0;
        var tk = setInterval(function () {
          attempts++;
          if (renderBrands() || attempts > 30) clearInterval(tk);
        }, 200);
      }
    }

    // Faz H-A3: Header 'Telefon Modeli Sec' butonu modal yerine Step 2 acsin
    function initShellModelButton() {
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-action="go-to-model-step"]');
        if (!t) return;
        e.preventDefault();
        openStep(2);
        var step = root.querySelector('.jw__step[data-step="2"]');
        if (step && step.scrollIntoView) {
          setTimeout(function () { step.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
        }
      });
    }

    // ------------------------------------------------------------------
    // 02 Telefon Modeli
    function initStep02Phone() {
      var brandSel = $('#jw-brand');
      var modelSel = $('#jw-model');
      if (!brandSel || !modelSel) return;
      var fillBrands = function () {
        var MODELS = (window.JET_FRAME && window.JET_FRAME.MODELS) || {};
        var brands = Object.keys(MODELS);
        brandSel.innerHTML = '';
        brands.unshift('');
        brands.forEach(function (b) {
          var o = document.createElement('option');
          o.value = b; o.textContent = b || '— Marka seç —';
          brandSel.appendChild(o);
        });
      };
      fillBrands();
      // Kullanici JET_FRAME.MODELS henuz yuklenmediyse polling
      if (!window.JET_FRAME || !window.JET_FRAME.MODELS) {
        var t = setInterval(function () {
          if (window.JET_FRAME && window.JET_FRAME.MODELS) {
            clearInterval(t); fillBrands();
          }
        }, 200);
      }
      brandSel.addEventListener('change', function () {
        var MODELS = (window.JET_FRAME && window.JET_FRAME.MODELS) || {};
        var arr = MODELS[brandSel.value] || [];
        modelSel.innerHTML = '';
        var ph = document.createElement('option');
        ph.value = ''; ph.textContent = arr.length ? '— Model seç —' : 'Model bulunamadı';
        modelSel.appendChild(ph);
        arr.forEach(function (m) {
          // m formati: [name, slug] tuple veya {name, slug} obj — ikisini de destekle
          var name = Array.isArray(m) ? m[0] : (m && m.name) || '';
          var slug = Array.isArray(m) ? m[1] : (m && m.slug) || '';
          var o = document.createElement('option');
          o.value = slug || name;
          o.textContent = name;
          modelSel.appendChild(o);
        });
      });
      // Faz 2.1: Combobox -> 2-select sync entry point. Programmatic dispatch
      // Faz 1.4 hasDesign+confirmation flow'unu da tetikler (event-driven).
      window.__jwSyncFromCombo = function (brand, slug, modelName) {
        if (!brandSel || !modelSel) return;
        for (var i = 0; i < brandSel.options.length; i++) {
          if (brandSel.options[i].value === brand) {
            brandSel.selectedIndex = i;
            brandSel.dispatchEvent(new Event('change'));
            break;
          }
        }
        // Brand change handler'i sync — modelSel populate hemen olur
        for (var j = 0; j < modelSel.options.length; j++) {
          var opt = modelSel.options[j];
          if (opt.value === slug || opt.text === modelName) {
            modelSel.selectedIndex = j;
            modelSel.dispatchEvent(new Event('change'));
            return;
          }
        }
      };

      modelSel.addEventListener('change', function () {
        // A2 (2026-09-25): yer tutucu ("— Model seç —", value='') secilince onayli model olarak
        // "— Model seç —" yaziliyor, varyant bulunamayinca iPhone 15 Pro Max ile sepete gidiyordu.
        if (!modelSel.value) return;
        var brand = brandSel.value;
        var modelName = modelSel.options[modelSel.selectedIndex].text;
        if (!window.JetAtolye || !window.JetAtolye.setModel) return;

        // Faz 1.4: Tasarim yapildiysa onay modal goster.
        // hasDesign = canvas'ta user-content (foto/text/sticker/template) var mi?
        var hasDesign = false;
        try {
          var c = window.JetAtolye.canvas && window.JetAtolye.canvas();
          if (c) {
            hasDesign = c.getObjects().some(function (o) {
              if (!o || o.name === '__jk_bg_layer') return false;
              return !!o.jkPhotoId
                || o.type === 'i-text' || o.type === 'textbox'
                || o.kind === 'sticker' || o.kind === 'template';
            });
          }
        } catch (e) {}

        if (!hasDesign) {
          window.JetAtolye.setModel(brand, modelName);
          return;
        }

        var prevModel = (window.JetAtolye.state && window.JetAtolye.state.model) || '';
        showModelChangeConfirm(modelName, function (confirmed) {
          if (confirmed) {
            window.JetAtolye.setModel(brand, modelName);
          } else {
            // Iptal: dropdown eski model adina geri al
            for (var i = 0; i < modelSel.options.length; i++) {
              if (modelSel.options[i].text === prevModel) {
                modelSel.selectedIndex = i; break;
              }
            }
          }
        });
      });
    }

    // ------------------------------------------------------------------
    // 03 Kilif Tipi (v2.6: variant-map ile MagSafe destek kontrolu)
    var _variantMap = null;
    var _variantMapPromise = null;
    var _variantMapFailed = false;
    function loadVariantMap() {
      if (_variantMap) return Promise.resolve(_variantMap);
      if (_variantMapPromise) return _variantMapPromise;
      var url = window.JET_VARIANT_MAP_URL;
      if (!url) { _variantMap = { tpu: {}, magsafe: {} }; return Promise.resolve(_variantMap); }
      // B3 (2026-09-24): tek fetch hatasi bos haritayi KALICI yapiyordu -> TPU her modelde kapali, musteri
      // takili ve mesajsiz kaliyordu. Simdi 3 deneme; hepsi basarisizsa bos harita cache'lenmez
      // (sonraki model-change yeniden dener) ve musteriye gorunur mesaj gider.
      var tries = 0;
      function attempt() {
        tries++;
        return fetch(url).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        }).catch(function (e) {
          if (tries >= 3) throw e;
          return new Promise(function (res) { setTimeout(res, tries * 1500); }).then(attempt);
        });
      }
      _variantMapPromise = attempt()
        .then(function (m) { _variantMap = m; _variantMapFailed = false; return m; })
        .catch(function (e) {
          console.warn('[WIZ] variant map fetch fail', e);
          _variantMapPromise = null;
          _variantMapFailed = true;
          if (window.JetAtolye && window.JetAtolye.notify) {
            window.JetAtolye.notify('Kılıf seçenekleri yüklenemedi. Bağlantını kontrol edip sayfayı yenile.', 'error', { duration: 8000 });
          }
          return { tpu: {}, magsafe: {} };
        });
      return _variantMapPromise;
    }

    // Aktif slug bu product type'da satilan modellerden biri mi?
    function productSupportsModel(productKey, slug) {
      if (!_variantMap || !_variantMap[productKey]) return false;
      return _variantMap[productKey][slug] != null;
    }

    // Faz 2.1: Desktop combobox UA detect + datalist populate + change handler.
    // Mobile (iOS Safari datalist quirk) icin 2-select fallback'a geri donulur.
    function initBrandModelCombo() {
      var ua = navigator.userAgent || '';
      var isIOS = /iPad|iPhone|iPod/.test(ua);
      var isMobile = /Mobi/.test(ua);
      // iPad Pro modern Safari "Mac" UA'sinde + maxTouchPoints>1 -> tablet
      var isTouchTablet = /iPad/.test(ua)
        || (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.platform || ''));
      var useNativeSelect = isIOS || isMobile || isTouchTablet;
      var combo = document.getElementById('jw-brand-model-combo');
      var list = document.getElementById('jw-brand-model-list');
      if (!combo || !list) return;
      if (!useNativeSelect) document.body.classList.add('jw-desktop-combo');

      // Datalist populate — JET_FRAME.MODELS hazirsa hemen, degilse polling.
      var attempts = 0;
      function populate() {
        var MODELS = (window.JET_FRAME && window.JET_FRAME.MODELS) || {};
        var brands = Object.keys(MODELS);
        if (!brands.length && attempts++ < 30) { setTimeout(populate, 200); return; }
        list.innerHTML = '';
        brands.forEach(function (brand) {
          (MODELS[brand] || []).forEach(function (m) {
            var name = Array.isArray(m) ? m[0] : (m && m.name) || '';
            var slug = Array.isArray(m) ? m[1] : (m && m.slug) || '';
            if (!name || !slug) return;
            var opt = document.createElement('option');
            opt.value = brand + ' — ' + name;  // Görünen label
            opt.dataset.slug = slug;
            opt.dataset.brand = brand;
            opt.dataset.modelName = name;
            list.appendChild(opt);
          });
        });
      }
      populate();

      // Combobox seçilince -> 2-select'i programmatic sync et (Faz 1.4 hasDesign flow korunur).
      // C9/A8 (2026-09-30): datalist tam eslesme istiyordu ("iphone16pro" -> hicbir sey). Buyuk/kucuk harf,
      // bosluk/tire, Turkce karakter ve "plus"/"+" normalize edilir; tam normalize eslesme yoksa sonu-eslesme
      // ("s25 fe" -> "Galaxy S25 FE") TEK adaysa secilir. Birden cok aday -> hicbir sey secilmez (yanlis model riski).
      function normModel(t) {
        return String(t || '').replace(/[İI]/g, 'i').replace(/ı/g, 'i').toLowerCase()
          .replace(/ğ/g, 'g').replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ö/g, 'o').replace(/ü/g, 'u')
          .replace(/plus/g, '+').replace(/[^a-z0-9+]/g, '');
      }
      function fuzzyFindOption(val) {
        var q = normModel(val);
        if (!q || q.length < 2) return null;
        var opts = list.options, i, o, ends = [];
        for (i = 0; i < opts.length; i++) {
          o = opts[i];
          var n = normModel(o.dataset.modelName), bn = normModel(o.dataset.brand + ' ' + o.dataset.modelName);
          if (q === n || q === bn) return o;
          if (n.length > q.length && n.slice(-q.length) === q && /[a-z]/.test(q) && /[0-9]/.test(q)) ends.push(o);
        }
        return ends.length === 1 ? ends[0] : null;
      }
      combo.addEventListener('change', function () {
        var val = combo.value;
        if (!val || !list.options) return;
        var hit = null;
        for (var i = 0; i < list.options.length; i++) {
          if (list.options[i].value === val) { hit = list.options[i]; break; }
        }
        if (!hit) { hit = fuzzyFindOption(val); if (hit) combo.value = hit.value; }
        if (hit && typeof window.__jwSyncFromCombo === 'function') {
          window.__jwSyncFromCombo(hit.dataset.brand, hit.dataset.slug, hit.dataset.modelName);
        }
      });
    }

    function initStep03Product() {
      var el = $('#jw-products');
      if (!el) return;
      var data = {};
      try { data = JSON.parse(root.dataset.products || '{}'); } catch (e) {}
      var icons = { seffaf: '✨', silikon: '🌈', magsafe: '🧲', deri: '👜', customizer: '🎨', tpu: '✨' };

      // v2.8.4 (madde 8b): Buton dinamik. S27v27 (2026-06-14): productKey null ise default
      // "Standart TPU ile devam et" YOK → "Önce kılıf tipi seç" prompt + visual disabled.
      function updateContinueLabel() {
        var btn = document.getElementById('jw-tip-continue');
        if (!btn) return;
        var key = state.productKey;
        if (!key) {
          btn.textContent = 'Önce kılıf tipi seç';
          btn.classList.add('is-disabled');
          return;
        }
        var p = data[key];
        var lbl = (p && p.label) ? p.label : (key === 'magsafe' ? 'MagSafe' : 'Standart TPU');
        btn.textContent = lbl + ' ile devam et →';
        btn.classList.remove('is-disabled');
      }

      // Tum kartlari olustur (active model'e gore daha sonra disable edilir)
      Object.keys(data).forEach(function (k) {
        var p = data[k];
        // S27v27 (2026-06-14): DEFAULT TPU SEÇİMİ KALDIRILDI.
        // Eskiden p.default ise state.productKey = 'tpu' + card is-active class veriliyordu.
        // Sorun: müşteri "zaten seçili" sanıp Devam'a tıklıyor, ama productKeyConfirmed false
        // kaldığı için ATC kilitli. Şimdi: müşteri BİLİNÇLİ olarak kart seçmek zorunda.
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'jw__product-card';
        card.dataset.handle = p.handle;
        card.dataset.productKey = k;  // 'tpu' | 'magsafe'
        card.innerHTML =
          '<div class="ico">' + (icons[k] || '📱') + '</div>' +
          '<div class="lbl">' + p.label + '</div>' +
          '<div class="price">' + p.price + '</div>';
        card.addEventListener('click', function () {
          if (card.disabled) return;
          $$('.jw__product-card').forEach(function (x) { x.classList.remove('is-active'); });
          card.classList.add('is-active');
          state.productHandle = p.handle;
          state.productKey = k;
          // Faz 1.1: core.js state'e bridge (productKeyConfirmed=true) + ATC reactive enable
          if (window.JetAtolye && window.JetAtolye.setProductKey) {
            window.JetAtolye.setProductKey(k, { handle: p.handle, confirmed: true });
          }
          updateContinueLabel();
        });
        el.appendChild(card);
      });

      // Init label set
      updateContinueLabel();
      // refreshProductAvailability fallback'lerinde de cagrilsin
      window.__jw_updateContinueLabel = updateContinueLabel;

      // Faz 2.2: "Devam Et" butonu manuel step ilerleme (otomatik gecis yasak).
      // Card click yalniz state.productKey set eder, step3->step4 gecis SADECE bu buton.
      var continueBtn = document.getElementById('jw-tip-continue');
      if (continueBtn && !continueBtn.__jwBound) {
        continueBtn.__jwBound = true;
        continueBtn.addEventListener('click', function () {
          // S27v27 (2026-06-14): TPU fallback KALDIRILDI.
          // Kart secilmediyse devam ETMEZ; toast uyari + sheet acik kalir.
          if (!state.productKey) {
            if (window.JetAtolye && window.JetAtolye.notify) {
              window.JetAtolye.notify('Lutfen kilif tipini sec', 'warning');
            }
            return;
          }
          // Step 4 (Fotograf) - manuel ilerleme
          openStep(4);
          // Step03 head'i scroll-out, step04'e focus
          var step4 = document.querySelector('.jw__step[data-step="4"]');
          if (step4 && step4.scrollIntoView) {
            setTimeout(function () { step4.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
          }
        });
      }

      // Variant map yukle, model degisimini dinle
      loadVariantMap().then(function () {
        // 2026-09-24: modelSlug wizard state'inde DEGIL, JetAtolye.state'te. state.modelSlug hep undefined
        // oldugu icin ?model=/taslak acilisinda erken disable edilen TPU karti soluk (opacity .35) kaliyordu.
        refreshProductAvailability(window.JetAtolye && window.JetAtolye.state && window.JetAtolye.state.modelSlug);
      });

      if (window.JetAtolye && window.JetAtolye.bus) {
        // A7 (2026-09-25): core'un (taslak/URL) kurdugu kilif tipi kart arayuzune yansisin
        window.JetAtolye.bus.on('product-change', function (e) {
          if (!e || !e.key || !e.confirmed) return;
          var pc = el.querySelector('.jw__product-card[data-product-key="' + e.key + '"]');
          if (!pc) return;
          $$('.jw__product-card').forEach(function (x) { x.classList.toggle('is-active', x === pc); });
          state.productKey = e.key;
          if (pc.dataset.handle) state.productHandle = pc.dataset.handle;
          updateContinueLabel();
        });
        window.JetAtolye.bus.on('model-change', function (e) {
          refreshProductAvailability(e && e.slug);
          // B3: harita yuklenemediyse model degisiminde yeniden dene, sonra tekrar degerlendir.
          // Not: _variantMap* var'lari boot() icinde initStep03Product() cagrisindan SONRA baslatiliyor ->
          // ilk yukleme surerken _variantMapPromise null'a donuyor; o yuzden tetik !_variantMap degil, _variantMapFailed.
          if (_variantMapFailed) {
            loadVariantMap().then(function () {
              refreshProductAvailability(window.JetAtolye && window.JetAtolye.state && window.JetAtolye.state.modelSlug);
            });
          }
        });
      }
    }

    // refreshProductAvailability: aktif slug bu product type'da satilan modellerden biri mi?
    // (productSupportsModel _variantMap'i kullanir)

    // v2.6: Aktif modele gore MagSafe (ve diger product) butonu enable/disable.
    function refreshProductAvailability(slug) {
      if (!slug) return;
      var cards = document.querySelectorAll('.jw__product-card');
      var activeKey = state.productKey || 'tpu';
      cards.forEach(function (card) {
        var key = card.dataset.productKey;
        if (!key) return;
        var supported = productSupportsModel(key, slug);
        if (supported) {
          card.disabled = false;
          card.style.display = '';
          card.style.opacity = '';
          card.title = '';
        } else {
          card.disabled = true;
          card.style.opacity = '0.35';
          card.title = _variantMapFailed
            ? 'Kılıf seçenekleri yüklenemedi, sayfayı yenile'
            : 'Bu model icin ' + (key === 'magsafe' ? 'MagSafe' : key.toUpperCase()) + ' mevcut degil';
          // Eger aktif kart bu ise TPU'ya zorla
          if (card.classList.contains('is-active') && key !== 'tpu') {
            card.classList.remove('is-active');
            var fallback = document.querySelector('.jw__product-card[data-product-key="tpu"]');
            if (fallback && !fallback.disabled) {
              fallback.classList.add('is-active');
              state.productHandle = fallback.dataset.handle;
              state.productKey = 'tpu';
            }
          }
        }
      });
      // v2.8 madde 8: fallback sonrasi label sync
      if (typeof window.__jw_updateContinueLabel === 'function') window.__jw_updateContinueLabel();
    }

    // v2.6: Aktif slug + productKey -> variant_id (ATC'de kullanilir)
    // _variantMap window'a ekspoze + sync getter (variant_map yuklendiyse)
    window.JetWizardGetVariantMap = function () { return _variantMap; };
    window.JetWizardGetVariantId = function () {
      // modelSlug wizard'in DEGIL JetAtolye.state'inin parcasi
      var slug = (window.JetAtolye && window.JetAtolye.state && window.JetAtolye.state.modelSlug) || null;
      if (!slug) return null;
      var key = state.productKey || 'tpu';
      if (_variantMap && _variantMap[key] && _variantMap[key][slug]) {
        return _variantMap[key][slug];
      }
      return null;
    };

    // Default product handle — initStep03Product cagrisinda data-products'tan default'u set et
    function setDefaultProduct() {
      try {
        var data = JSON.parse(root.dataset.products || '{}');
        for (var k in data) {
          if (data[k] && data[k].default) {
            // S27v27 (2026-06-14): Sadece handle set edilir (variant resolver fallback icin).
            // state.productKey BILINCLI secim icin null kalir; kullanici karta tiklamadan
            // ATC enable OLMAZ, buton "Once kilif tipi sec" gosterir.
            state.productHandle = data[k].handle;
            break;
          }
        }
      } catch(e) {}
    }
    setDefaultProduct();
    
    // Q.7 (2026-05-02): URL ?caseType=magsafe → MagSafe pre-select
    try {
      var urlCaseType = new URLSearchParams(location.search).get('caseType');
      if (urlCaseType === 'magsafe' || urlCaseType === 'tpu') {
        state.productKey = urlCaseType;
        // products data'dan handle al
        var rootEl = document.querySelector('[data-products]');
        if (rootEl) {
          var pdata = JSON.parse(rootEl.dataset.products || '{}');
          if (pdata[urlCaseType]) state.productHandle = pdata[urlCaseType].handle;
        }
        // UI button active state senkron — variant map yüklendikten sonra
        function syncCaseTypeButtonsFromUrl() {
          document.querySelectorAll('.jw__product-card').forEach(function(c){
            c.classList.toggle('is-active', c.dataset.productKey === urlCaseType);
          });
        }
        setTimeout(syncCaseTypeButtonsFromUrl, 1200);
        setTimeout(syncCaseTypeButtonsFromUrl, 3000);
      }
    } catch(e) { console.warn('[WIZ] caseType url param parse fail', e); }

    // ------------------------------------------------------------------
    // 04 Fotograf — JetPhotoLibrary kopru
    function initStep04Photo() {
      var btn = $('#jw-upload-btn');
      var input = $('#jw-photo-input');
      var tiles = $('#jw-photo-tiles');
      if (!btn || !input || !tiles) {
        console.warn('[WIZ-PHOTO] init skip:', !!btn, !!input, !!tiles);
        return;
      }
      console.log('[WIZ-PHOTO] init OK — buton bağlandı');

      // v2.8.2 (kullanici talebi): KVKK/telif onay modali KALDIRILDI.
      // Site genelinde KVKK/Aydinlatma metni linkleri (footer + checkout) yeterli.
      btn.addEventListener('click', function () { input.click(); });
      input.addEventListener('change', function (e) {
        var files = Array.from(e.target.files || []);
        console.log('[WIZ-PHOTO] file selected:', files.length);
        // S27v24 (2026-05-31): ilk foto upload sonrasi sheet'i otomatik kapat
        var wasEmpty = !!(window.JetPhotoLibrary && window.JetPhotoLibrary.list().length === 0);
        var addPromises = files.map(function (f) {
          if (window.JetPhotoLibrary && window.JetPhotoLibrary.add) {
            return window.JetPhotoLibrary.add(f).then(function (id) {
              refreshTiles();
              // G.8 — Auto-add to canvas: yüklenen foto otomatik kanvasa eklensin
              var photo = window.JetPhotoLibrary.list().find(function (p) { return p.id === id; });
              if (photo) addPhotoToCanvas(photo.dataUrl, photo.id);
            }).catch(function (err) {
              console.error('[WIZ-PHOTO] add fail:', err);
            });
          } else {
            // Fallback: object URL
            var url = URL.createObjectURL(f);
            addTile(url, null);
            addPhotoToCanvas(url, null);
            return Promise.resolve();
          }
        });
        // S27v24: tum dosyalar islendikten sonra, ilk foto idiyse sheet'i kapat
        Promise.all(addPromises).then(function () {
          if (wasEmpty && window.JetWizardSheet && window.JetWizardSheet.isOpen && window.JetWizardSheet.isOpen()) {
            window.JetWizardSheet.close();
          }
        });
        input.value = '';
      });

      // C3 (2026-09-30, METIN PAKETI): seffaf alanli tasarim PNG'si -> kamera cevresi baskida beyaz cikiyordu.
      function jkWaLink() {
        var a = document.querySelector('a.jet-wa-fab-atolye[href*="wa.me/"], a[href*="wa.me/"]');
        var m = a && /wa\.me\/(\d{8,15})/.exec(a.getAttribute('href') || '');
        return m ? 'https://wa.me/' + m[1] : '';
      }
      function transparentRatio(imgEl) {
        try {
          var cv = document.createElement('canvas'); cv.width = 100; cv.height = 100;
          var x = cv.getContext('2d'); x.drawImage(imgEl, 0, 0, 100, 100);
          var d = x.getImageData(0, 0, 100, 100).data, t = 0;
          for (var i = 3; i < d.length; i += 4) if (d[i] < 250) t++;
          return t / 10000;
        } catch (e) { return 0; } // CORS/taint -> sessiz gec
      }
      function warnIfTransparent(url, id, im) {
        if (typeof url !== 'string' || !(url.indexOf('data:image/png') === 0 || url.indexOf('data:image/webp') === 0)) return;
        var wk = id || url.length + ':' + url.slice(-32);
        state._transWarned = state._transWarned || {};
        if (state._transWarned[wk]) return;   // kucuk resme tekrar tiklamada yeniden uyarma
        state._transWarned[wk] = true;
        if (transparentRatio(im.getElement ? im.getElement() : im._element) < 0.02) return;
        var wa = jkWaLink();
        var msg = 'Tasarımında şeffaf alan var. Kamera bölgesini şablondaki kamerayla hizala ya da bir arkaplan rengi seç — boş kalan yer baskıda beyaz çıkar. Yapamazsan bize yaz, biz ayarlayalım'
          + (wa ? ': <a href="' + wa + '" target="_blank" rel="noopener" class="jk-trans-wa" style="color:inherit;text-decoration:underline;font-weight:700">WhatsApp</a>' : '.');
        if (window.JetAtolye && window.JetAtolye.notify) window.JetAtolye.notify(msg, 'warning', { duration: 12000 });
      }

      // M2 + G.8 — Foto'yu canvas'a layout-aware cover ile ekle
      function addPhotoToCanvas(url, id) {
        if (!window.JetAtolye || !window.JetAtolye.canvas || !window.fabric) return;
        var c = window.JetAtolye.canvas();
        if (!c) { console.error('[WIZ-PHOTO] canvas null'); return; }
        // Aynı foto zaten canvas'taysa skip
        if (id) {
          var dupe = c.getObjects().find(function (o) { return o.jkPhotoId === id; });
          // Sablon v2: bos yuvaya dokunup kutuphaneden kanvastaki bir fotoyu secti -> o yuvaya tasi (doluysa yer degistir)
          var pend = dupe && state.pendingSlot && tplFindSlot(c, state.pendingSlot);
          if (pend && dupe.jkTplSlot !== pend.jkTplSlot) {
            state.pendingSlot = null;
            var ja0 = window.JetAtolye;
            var move = function () {
              var occ = tplOccupant(c, pend);
              var from = dupe.jkTplSlot ? tplFindSlot(c, dupe.jkTplSlot) : null;
              tplPlacePhoto(c, dupe, pend);
              if (occ) { if (from) tplPlacePhoto(c, occ, from); else c.remove(occ); }
            };
            if (ja0.undoBatch) ja0.undoBatch(move); else move();
            c.setActiveObject(dupe);
            c.requestRenderAll();
            return;
          }
          if (dupe) {
            c.setActiveObject(dupe);
            c.requestRenderAll();
            return;
          }
        }
        // v2.2: dinamik PA
        var PA = (window.JetAtolye && window.JetAtolye.getPrintBounds && window.JetAtolye.getPrintBounds())
              || { x: 55, y: 60, w: 490, h: 960, r: 80, cx: 300, cy: 540 };
        if (typeof PA.cx !== 'number') PA.cx = PA.x + PA.w / 2;
        if (typeof PA.cy !== 'number') PA.cy = PA.y + PA.h / 2;
        if (typeof PA.r !== 'number') PA.r = 80;
        var layout = state.activeLayout || 'single';
        window.fabric.Image.fromURL(url, function (im, isError) {
          // B-12 (2026-09-25): sahte/bozuk .jpg gorunmez 0x0 nesne olarak ekleniyordu, uyari yoktu.
          if (!im || isError || !im.width || !im.height) {
            if (id && window.JetPhotoLibrary && window.JetPhotoLibrary.remove) window.JetPhotoLibrary.remove(id);
            if (window.JetAtolye && window.JetAtolye.notify) {
              window.JetAtolye.notify('Bu fotoğraf açılamadı — dosya bozuk ya da desteklenmeyen biçimde. JPG veya PNG olarak kaydedip yeniden yükle.', 'error', { duration: 7000 });
            }
            return;
          }
          warnIfTransparent(url, id, im);

          // Sablon v2: kanvasta kompozit sablon yuvasi varsa foto yuvaya girer (bekleyen yuva > ilk bos yuva)
          var tSlots = tplGetSlots(c);
          if (tSlots.length) {
            var target = (state.pendingSlot && tplFindSlot(c, state.pendingSlot))
              || tSlots.filter(function (s) { return s.slotEmpty; })[0];
            state.pendingSlot = null;
            if (!target) {
              if (window.JetAtolye && window.JetAtolye.notify) {
                window.JetAtolye.notify('Fotoğraf yuvaları dolu. Değiştirmek istediğin yuvadaki fotoğrafı seçip sil, sonra yenisini ekle.', 'warning', { duration: 7000 });
              }
              return;
            }
            im.set({ jkPhotoId: id });
            var tsc = 1, ja1 = window.JetAtolye;
            var put = function () {
              var occ = tplOccupant(c, target);
              if (occ) c.remove(occ);
              tsc = tplPlacePhoto(c, im, target);
            };
            if (ja1.undoBatch) ja1.undoBatch(put); else put();
            if (Math.round(166 / (tsc || 1)) < 150 && ja1.notify) {
              ja1.notify('Bu fotoğrafın çözünürlüğü düşük (' + im.width + '×' + im.height + ' px); baskıda bulanık görünebilir. Daha büyük bir fotoğraf yüklemeni öneririz.', 'warning', { duration: 8000 });
            }
            c.setActiveObject(im);
            c.requestRenderAll();
            console.log('[WIZ-PHOTO] tpl slot fill:', target.jkTplSlot);
            return;
          }

          if (layout === 'single') {
            // Faz J-9 (2026-05-07): SAFE INSET %6 + aspect-aware cover/fit.
            var insetX = PA.w * 0.08, insetY = PA.h * 0.08;
            var safeW = PA.w - 2 * insetX, safeH = PA.h - 2 * insetY;
            var iw = im.width || 1, ih = im.height || 1;
            var coverScale = Math.max(safeW / iw, safeH / ih);
            var fitScale = Math.min(safeW / iw, safeH / ih);
            var photoAR = iw / ih, caseAR = safeW / safeH;
            var aspectMatch = Math.min(photoAR, caseAR) / Math.max(photoAR, caseAR);
            var scale = aspectMatch >= 0.80 ? coverScale : fitScale;
            // B-02 (2026-09-25): dusuk cozunurluk uyarisi yoktu (120x120 foto x3,75 buyutulup yayiliyordu).
            // Kilif baski genisligi ~7,5 cm = 490 kanvas birimi -> efektif DPI ~ 166 / olcek.
            var effDpi = Math.round(166 / (scale || 1));
            if (effDpi < 150 && window.JetAtolye && window.JetAtolye.notify) {
              window.JetAtolye.notify('Bu fotoğrafın çözünürlüğü düşük (' + iw + '×' + ih + ' px); baskıda bulanık görünebilir. Daha büyük bir fotoğraf yüklemeni öneririz.', 'warning', { duration: 8000 });
            }
            im.set({
              left: PA.cx,
              top: PA.cy,
              originX: 'center', originY: 'center',
              scaleX: scale, scaleY: scale,
              jkPhotoId: id,
              lockUniScaling: true,
            });
            c.add(im);
            im.setCoords();
            c.setActiveObject(im);
            c.requestRenderAll();
            console.log('[WIZ-PHOTO] J-8 added:', id, 'scale=', scale.toFixed(3), 'mode=', aspectMatch >= 0.80 ? 'cover' : 'fit', 'aspectMatch=', aspectMatch.toFixed(2));
            return;
          }

          // Mosaic/polaroid: ilk boş slot'u bul + cover
          var emptySlot = c.getObjects().find(function (o) {
            return o.isCollageSlot && o.slotEmpty && !o.slotIsInner;
          });
          if (!emptySlot) {
            console.warn('[WIZ-PHOTO] mosaic slot dolu — toast');
            if (window.JetAtolye && window.JetAtolye.notify) {
              window.JetAtolye.notify('Tüm slot dolu — yeni foto için bir slot boşalt', 'warning');
            }
            return;
          }
          var slotW = emptySlot.width || 100;
          var slotH = emptySlot.height || 100;
          var slotCx = emptySlot.left;
          var slotCy = emptySlot.top;
          // Polaroid'de inner Rect target hedef olabilir, slot kullanırız
          var slotScale = Math.max(slotW / im.width, slotH / im.height);
          var isPolaroid = emptySlot.slotShape === 'polaroid';
          im.set({
            left: slotCx,
            top: slotCy,
            originX: 'center', originY: 'center',
            scaleX: slotScale, scaleY: slotScale,
            angle: emptySlot.angle || 0,
            jkPhotoId: id,
            jkSlotIndex: emptySlot.slotIndex,
            clipPath: new window.fabric.Rect({
              left: slotCx - slotW/2, top: slotCy - slotH/2,
              width: slotW, height: slotH,
              absolutePositioned: true,
              angle: emptySlot.angle || 0,
            }),
            // v2.6: Slot foto kilit — slot icinde drag serbest, scale/rotate kilit
            // Polaroid haric (kullanici polaroid'i istedigi sekilde duzenleyebilir)
            lockScalingX: !isPolaroid,
            lockScalingY: !isPolaroid,
            lockRotation: !isPolaroid,
            hasControls: isPolaroid,  // toolbar handle gizle (slot foto icin)
          });
          c.add(im);
          emptySlot.slotEmpty = false;
          var slotIdx = emptySlot.slotIndex;
          // Foto eklendi → guide artifact'larını temizle:
          // - Mosaic: slot Rect (gri dashed) sil — foto zaten cell'i dolduruyor
          // - Polaroid: bg beyaz kart KORU (görsel polaroid çerçeve), inner dashed sil
          c.getObjects().filter(function (o) {
            if (o === im || !o.isCollageSlot || o.slotIndex !== slotIdx) return false;
            if (isPolaroid && !o.slotIsInner) return false; // polaroid bg korunur
            return true;
          }).forEach(function (o) { c.remove(o); });
          // Polaroid'de foto bg'nin ÜZERİNE çıksın (beyaz kart altta görünür kalır)
          if (isPolaroid) {
            c.bringToFront(im);
          }
          im.setCoords();
          c.setActiveObject(im);
          c.requestRenderAll();
          console.log('[WIZ-PHOTO] slot fill:', slotIdx, 'polaroid:', isPolaroid);
        }, { crossOrigin: 'anonymous' });
      }
      function refreshTiles() {
        if (!window.JetPhotoLibrary || !window.JetPhotoLibrary.list) return;
        tiles.innerHTML = '';
        // F.6.6 BUG FIX: önceki kod p.url kullanıyordu ama JetPhotoLibrary.list()
        // photo.dataUrl döner — broken image sebebi!
        window.JetPhotoLibrary.list().forEach(function (p) { addTile(p.dataUrl, p.id); });
        console.log('[WIZ-PHOTO] refreshTiles, lib:', window.JetPhotoLibrary.list().length);
      }
      function addTile(url, id) {
        var tile = document.createElement('div');
        tile.className = 'tile';
        tile.draggable = true;
        if (id) tile.dataset.id = id;
        var im = document.createElement('img');
        im.src = url;
        im.onerror = function() { console.error('[WIZ-PHOTO] thumb img error, src len:', (url || '').length); };
        tile.appendChild(im);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'x';
        x.textContent = '×';
        x.addEventListener('click', function (ev) {
          ev.stopPropagation();
          // F.6.7 fix (kullanıcı isteği): tile sil → canvas'taki aynı foto da silinsin
          if (id && window.JetAtolye && window.JetAtolye.canvas) {
            var c = window.JetAtolye.canvas();
            if (c) {
              c.getObjects().filter(function(o){ return o.jkPhotoId === id; }).forEach(function(o){
                c.remove(o);
              });
              c.requestRenderAll();
              console.log('[WIZ-PHOTO] canvas\'tan da silindi:', id);
            }
          }
          if (id && window.JetPhotoLibrary && window.JetPhotoLibrary.remove) {
            window.JetPhotoLibrary.remove(id);
          }
          tile.remove();
        });
        tile.appendChild(x);
        tile.addEventListener('click', function () {
          console.log('[WIZ-PHOTO] tile click → addToCanvas');
          addPhotoToCanvas(url, id);
        });
        tiles.appendChild(tile);
      }
      // JetPhotoLibrary değişimi dinle (drag-drop sonrası tile refresh)
      if (window.JetPhotoLibrary && window.JetPhotoLibrary.on) {
        window.JetPhotoLibrary.on(refreshTiles);
      }
      refreshTiles();

      // Sablon v2: bos (ya da dolu) yuva yer tutucusuna dokun -> o yuva icin foto sec.
      // Kutuphanede foto varsa Foto adimi acilir (kucuk resme dokun = yuvaya koy), yoksa dosya secici acilir.
      whenCanvas(function (c) {
        var downOn = null;
        c.on('mouse:down', function (e) {
          var t = e && e.target;
          downOn = (t && t.isCollageSlot && t.jkTplSlot) ? t : null;
        });
        c.on('mouse:up', function (e) {
          var t = e && e.target;
          if (!t || t !== downOn) return;
          downOn = null;
          state.pendingSlot = t.jkTplSlot;
          var lib = (window.JetPhotoLibrary && window.JetPhotoLibrary.list && window.JetPhotoLibrary.list()) || [];
          if (!lib.length) { input.click(); return; }
          if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches && window.JetWizardSheet) {
            window.JetWizardSheet.open('4', { locked: false });
          } else {
            openStep(4);
          }
          if (window.JetAtolye && window.JetAtolye.notify) {
            window.JetAtolye.notify('Bu yuvaya koymak için fotoğraflarından birine dokun ya da yeni fotoğraf yükle.', 'info', { duration: 5000 });
          }
        });
      });
    }

    // ------------------------------------------------------------------
    // M3: Layout Gate — Step 1 başında zorunlu seçim
    function initLayoutGate() {
      var gate = document.getElementById('jw-layout-gate');
      if (!gate) { console.warn('[LAYOUT-GATE] not found'); return; }
      var changeBtn = document.getElementById('jw-layout-change');

      // Restore: cached layout varsa gate'i is-confirmed yap + ilgili butonu active
      if (state.activeLayout) {
        gate.classList.add('is-confirmed');
        var savedBtn = gate.querySelector('.jw__layout-opt[data-layout="' + state.activeLayout + '"]');
        if (savedBtn) savedBtn.classList.add('is-active');
        if (changeBtn) changeBtn.hidden = false;
        // Apply layout to canvas (idempotent — single = no-op)
        applyLayoutToCanvas(state.activeLayout, true);
      }

      $$('.jw__layout-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var newLayout = opt.dataset.layout;
          if (state.activeLayout && state.activeLayout !== newLayout) {
            // Confirm dialog: mevcut tasarım sıfırlanacak
            if (window.JetAtolye && window.JetAtolye.confirmInline) {
              window.JetAtolye.confirmInline({
                title: 'Düzeni değiştir?',
                body: 'Mevcut tasarımın silinecek ve yeni düzene göre sıfırlanacak. Devam edilsin mi?',
                ok: 'Evet, değiştir',
                cancel: 'Vazgeç',
              }).then(function (yes) {
                if (yes) commitLayout(newLayout);
              });
              return;
            }
            if (!window.confirm('Mevcut tasarımın sıfırlanacak. Devam?')) return;
          }
          commitLayout(newLayout);
        });
      });

      if (changeBtn) {
        changeBtn.addEventListener('click', function () {
          // Re-open gate (mode tabs tekrar kilitlenir)
          gate.classList.remove('is-confirmed');
          changeBtn.hidden = true;
          $$('.jw__layout-opt').forEach(function (b) { b.classList.remove('is-active'); });
        });
      }

      function commitLayout(newLayout) {
        $$('.jw__layout-opt').forEach(function (b) { b.classList.toggle('is-active', b.dataset.layout === newLayout); });
        state.activeLayout = newLayout;
        try { localStorage.setItem('jk_active_layout', newLayout); } catch(e) {}
        gate.classList.add('is-confirmed');
        if (changeBtn) changeBtn.hidden = false;
        applyLayoutToCanvas(newLayout, false);
        console.log('[LAYOUT-GATE] commit:', newLayout);
      }
    }

    // M3: Layout'a göre canvas davranışı uygula
    function applyLayoutToCanvas(layout, isRestore) {
      if (!window.JetAtolye || !window.JetAtolye.canvas) return;
      var c = window.JetAtolye.canvas();
      if (!c) return;
      // Mevcut slot'ları temizle (restore'da da temizle, idempotent)
      c.getObjects().filter(function (o) { return o.isCollageSlot; }).forEach(function (o) { c.remove(o); });
      if (layout === 'single') {
        // Tek foto modu — slot yok
        c.requestRenderAll();
        return;
      }
      if (layout === 'polaroid') {
        applyPolaroidLayout(c);
        return;
      }
      // Mosaic 4x9 (yoğun) / 3x6 (denge) / 2x4 (büyük cell'ler)
      // 2x6 → 2x4: cell aspect 1.96/2 = 0.98 (kare-yakın, telefon kılıfı oranıyla uyumlu)
      // 3x7 → 3x6: cell aspect (PA.w/3) / (PA.h/6) ≈ 1.02 (kare)
      // 4x9 korundu: cell aspect 1.15
      var dims = { 'mosaic-4x9': [4, 9], 'mosaic-3x7': [3, 6], 'mosaic-2x6': [2, 4] };
      var d = dims[layout];
      if (d) applyMosaicLayout(c, d[0], d[1]);
    }

    // v2.6: Slot'lar dinamik print area'ya gore yerlestirilir (model bazli).
    function _getPA() {
      return (window.JetAtolye && window.JetAtolye.getPrintBounds && window.JetAtolye.getPrintBounds())
          || { x: 80, y: 90, w: 440, h: 900, cx: 300, cy: 540 };
    }

    function applyMosaicLayout(c, cols, rows) {
      var PA = _getPA();
      // Cell padding 3px (slot'lar arası gap)
      var GAP = 3;
      var cellW = PA.w / cols;
      var cellH = PA.h / rows;
      for (var r = 0; r < rows; r++) {
        for (var col = 0; col < cols; col++) {
          var slot = new window.fabric.Rect({
            left: PA.x + col * cellW + GAP,
            top: PA.y + r * cellH + GAP,
            width: cellW - GAP * 2,
            height: cellH - GAP * 2,
            rx: 6, ry: 6, // hafif yuvarlak
            fill: 'rgba(0,0,0,0.025)', // çok hafif gri (önceden parlak pembe)
            stroke: '#BFBFBF',         // soft gri (önceden #FF6B5D kırmızı)
            strokeDashArray: [3, 4],
            strokeWidth: 1,
            selectable: false,
            evented: false,
            isCollageSlot: true,
            slotIndex: r * cols + col,
            slotEmpty: true,
          });
          c.add(slot);
        }
      }
      c.requestRenderAll();
    }

    function applyPolaroidLayout(c) {
      // 4x2 simetrik grid — her satır + kolon eşit aralıklı, hafif rotation alternation.
      // Eski versiyon: rastgele offset'ler (right kolon her satırda farklı topRow) → dağınık
      // görünüyordu. Yeni: kare grid + ±5° tilt (estetik polaroid hissi, ama düzgün).
      var PA = _getPA();
      var COLS = 2, ROWS = 4;
      // Polaroid kart boyutu: PA genişliğinin ~%40'ı, aspect 1:1.18
      var pw = Math.round(PA.w * 0.40);
      var ph = Math.round(pw * 1.18);
      // Eşit dağılım: her hücre PA.w/COLS × PA.h/ROWS, polaroid hücre merkezine yerleşir
      var cellW = PA.w / COLS;
      var cellH = PA.h / ROWS;
      var tilt = [-5, 5, 5, -5, -5, 5, 5, -5]; // alternating
      var positions = [];
      for (var r = 0; r < ROWS; r++) {
        for (var col = 0; col < COLS; col++) {
          positions.push({
            left: PA.x + cellW * (col + 0.5),
            top:  PA.y + cellH * (r + 0.5),
            angle: tilt[r * COLS + col] || 0,
          });
        }
      }
      var idx = 0;
      positions.forEach(function (p) {
        var bg = new window.fabric.Rect({
          left: p.left, top: p.top, width: pw, height: ph, originX: 'center', originY: 'center',
          fill: '#FFFFFF', stroke: '#1A1A1A', strokeWidth: 2,
          rx: 4, ry: 4, // hafif yuvarlak köşe
          angle: p.angle,
          selectable: false, evented: false,
          isCollageSlot: true,
          slotIndex: idx,
          slotEmpty: true,
          slotShape: 'polaroid',
          shadow: new window.fabric.Shadow({ color: 'rgba(0,0,0,0.18)', blur: 6, offsetX: 2, offsetY: 3 }),
        });
        // İç fotoğraf alanı (üstte, altta polaroid label area)
        var innerW = pw - Math.round(pw * 0.10);
        var innerH = ph - Math.round(ph * 0.27);
        var innerOffsetY = -Math.round(ph * 0.075);
        var inner = new window.fabric.Rect({
          left: p.left, top: p.top + innerOffsetY, width: innerW, height: innerH, originX: 'center', originY: 'center',
          fill: 'rgba(0,0,0,0.04)', stroke: '#BFBFBF', strokeDashArray: [3,4], strokeWidth: 1,
          angle: p.angle,
          selectable: false, evented: false,
          isCollageSlot: true,
          slotIndex: idx,
          slotIsInner: true,
        });
        c.add(bg);
        c.add(inner);
        idx++;
      });
      c.requestRenderAll();
    }

    // M3: applyLocalGrid + showCollageCancelButton kaldırıldı (Step 1 layout-gate'e taşındı).
    // Mosaic/polaroid layout artık applyMosaicLayout/applyPolaroidLayout (yukarıda) ile yönetilir.

    // ------------------------------------------------------------------
    // 05 Filtre — Fabric.js native filtreler (M3 sonrası numara: eski 06)
    function initStep06Filter() {
      var slider = $('#jw-filter-intensity');
      var reset = root.querySelector('[data-action="filter-reset"]');
      var apply = function () {
        if (!state.activeFilter) return;
        applyFilterToActive(state.activeFilter, parseInt(slider.value, 10) / 100);
      };
      // B-01: buyuk fotoda (Canvas2D yolu) her input olayinda yeniden filtre pahali -> kisa bekleme
      var sliderT = null;
      if (slider) slider.addEventListener('input', function () { clearTimeout(sliderT); sliderT = setTimeout(apply, 120); });
      if (slider) slider.addEventListener('change', function () { clearTimeout(sliderT); apply(); commitFilterChange(); });
      if (reset) reset.addEventListener('click', function () {
        state.activeFilter = null;
        $$('.jw__filter-card').forEach(function (x) { x.classList.remove('is-active'); });
        clearFiltersOnActive();
      });
      $$('.jw__filter-card').forEach(function (card) {
        card.addEventListener('click', function () {
          $$('.jw__filter-card').forEach(function (x) { x.classList.remove('is-active'); });
          card.classList.add('is-active');
          state.activeFilter = card.dataset.filter;
          apply();
          commitFilterChange();
        });
      });
    }

    function getActiveImage() {
      if (!window.JetAtolye || !window.JetAtolye.canvas) return null;
      var c = window.JetAtolye.canvas();
      if (!c) return null;
      var obj = c.getActiveObject();
      if (obj && obj.type === 'image') return { canvas: c, obj: obj };
      // bos ise tum image'lere uygula
      var imgs = c.getObjects().filter(function (o) { return o.type === 'image'; });
      if (imgs.length) return { canvas: c, obj: null, all: imgs };
      return null;
    }

    // B-01 (2026-09-25): Fabric WebGL filtresi varsayilan 2048 px doku kullaniyor; 4032x3024 fotoda
    // 2048 disi alfa 0 kaliyor, baski dosyasi fotonun ~2/3'u silinmis gidiyordu. Doku fotoya gore buyutulur
    // (<=4096, cihaz destekliyorsa); daha buyuk fotoda Canvas2D arka ucu (her boyutta dogru, daha yavas).
    function ensureFilterBackend(im) {
      var F = window.fabric;
      if (!F || !im) return;
      var el = im._originalElement || im._element;
      if (!el) return;
      var need = Math.max(el.naturalWidth || el.width || 0, el.naturalHeight || el.height || 0);
      var fb = F.filterBackend;
      if (fb && !fb.tileSize) return;              // zaten Canvas2D
      if (fb && fb.tileSize >= need) return;       // WebGL dokusu yeterli
      if (!fb && (F.textureSize || 2048) >= need) return;  // ilk kullanimda Fabric kendisi kurar
      var size = 2048;
      while (size < need) size *= 2;
      var next = null;
      try {
        if (size <= 4096 && F.WebglFilterBackend && F.isWebglSupported && F.isWebglSupported(size)) {
          F.textureSize = size;
          next = new F.WebglFilterBackend({ tileSize: size });
        }
      } catch (e) { next = null; }
      if (!next && F.Canvas2dFilterBackend) next = new F.Canvas2dFilterBackend();
      if (!next) return;
      try { if (fb && fb.dispose) fb.dispose(); } catch (e) {}
      F.filterBackend = next;
    }

    function applyFilterToActive(kind, intensity) {
      var f = window.fabric && window.fabric.Image && window.fabric.Image.filters;
      if (!f) return;
      var ctx = getActiveImage();
      if (!ctx) return;
      var build = function () {
        // Mevcut 3 filtre
        if (kind === 'mono') return [new f.Grayscale(), new f.Contrast({ contrast: intensity * 0.4 })];
        if (kind === 'digicam') return [new f.Saturation({ saturation: -0.3 + intensity * 0.6 }), new f.Contrast({ contrast: intensity * 0.5 }), new f.Noise({ noise: intensity * 40 })];
        if (kind === 'retro') return [new f.Saturation({ saturation: intensity * 0.8 }), f.Vibrance ? new f.Vibrance({ vibrance: intensity }) : new f.Saturation({ saturation: intensity * 0.4 })];
        // M4: 9 yeni VSCO filtre
        if (kind === 'sepia') return [new f.Sepia(), new f.Brightness({ brightness: intensity * 0.05 })];
        if (kind === 'bright') return [new f.Brightness({ brightness: intensity * 0.5 })];
        if (kind === 'contrast') return [new f.Contrast({ contrast: intensity * 0.5 })];
        if (kind === 'vintage') return [new f.Sepia(), new f.Contrast({ contrast: intensity * 0.1 }), new f.Brightness({ brightness: intensity * -0.05 }), new f.Saturation({ saturation: intensity * -0.2 })];
        if (kind === 'noir') return [new f.Grayscale(), new f.Contrast({ contrast: intensity * 0.3 }), new f.Brightness({ brightness: intensity * -0.05 })];
        if (kind === 'polaroid') return [new f.Saturation({ saturation: intensity * -0.2 }), new f.Brightness({ brightness: intensity * 0.1 }), new f.Contrast({ contrast: intensity * -0.05 })];
        if (kind === 'vivid') return [new f.Saturation({ saturation: intensity * 0.5 }), new f.Contrast({ contrast: intensity * 0.2 })];
        if (kind === 'faded') return [new f.Saturation({ saturation: intensity * -0.4 }), new f.Brightness({ brightness: intensity * 0.1 }), new f.Contrast({ contrast: intensity * -0.1 })];
        if (kind === 'vignette') {
          // Fabric'te native Vignette yok — radial darkening yerine ColorMatrix ile sahte:
          // Brightness reduce + slight contrast boost yapıp gerçek vignette için clipPath ile ayrı handle
          return [new f.Brightness({ brightness: intensity * -0.15 }), new f.Contrast({ contrast: intensity * 0.15 })];
        }
        return [];
      };
      var apply = function (im) {
        ensureFilterBackend(im);
        im.filters = build();
        im.applyFilters();
      };
      if (ctx.obj) apply(ctx.obj);
      else if (ctx.all) ctx.all.forEach(apply);
      ctx.canvas.requestRenderAll();
    }
    function commitFilterChange() {
      var ctx = getActiveImage();
      if (ctx) fireModified(ctx.canvas, ctx.obj || (ctx.all && ctx.all[0]));
    }

    function clearFiltersOnActive() {
      var ctx = getActiveImage();
      if (!ctx) return;
      var clear = function (im) { ensureFilterBackend(im); im.filters = []; im.applyFilters(); };
      if (ctx.obj) clear(ctx.obj);
      else if (ctx.all) ctx.all.forEach(clear);
      ctx.canvas.requestRenderAll();
      fireModified(ctx.canvas, ctx.obj || (ctx.all && ctx.all[0]));
    }

    // B-07 (2026-09-25): panelden yapilan yazi/renk/font/filtre degisiklikleri object:modified uretmiyordu ->
    // taslaga ve Geri al'a girmiyordu (tek Geri al yaziyi siliyordu). Ayrik eylemde hemen; surekli girdide
    // (yazi kutusu, renk secici, kaydirici) 'change' aninda cagrilir — gecikmeli kayit Geri al sirasini bozuyordu.
    function fireModified(c, obj) {
      if (!c || !obj) return;
      try { c.fire('object:modified', { target: obj }); } catch (e) {}
    }

    // ------------------------------------------------------------------
    // M5: Yazı (live preview + 18 font + renk + stroke + hizalama)
    function initStep07Text() {
      var input = $('#jw-text-input');
      var addBtn = $('#jw-add-text');
      var fonts = $$('.jw__font-card');
      var swatches = $$('#jw-text-swatches .jw__sw');
      var picker = $('#jw-text-color-picker');
      var aligns = $$('.jw__al');
      var strokeSlider = $('#jw-text-stroke');
      var strokeVal = $('#jw-stroke-val');

      // M5 state — son seçilen değerler (yeni yazı eklemek için default)
      var selectedFont = 'Inter';
      var selectedColor = '#1A1A1A';
      var selectedAlign = 'left';
      var selectedStroke = 0;

      // M5: Aktif IText obje (live preview için)
      function getActiveIText() {
        if (!window.JetAtolye || !window.JetAtolye.canvas) return null;
        var c = window.JetAtolye.canvas();
        if (!c) return null;
        var o = c.getActiveObject();
        if (o && (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox')) return o;
        return null;
      }
      function refreshActive() {
        var c = window.JetAtolye && window.JetAtolye.canvas();
        if (c) c.requestRenderAll();
      }

      // #9 (2026-10-03): mobilde yazi ekleme kolaylasti.
      //  - Ilk tusta yazi kanvasa eklenir ve her tusta guncellenir (liveText: henuz onaylanmamis yazi).
      //  - Enter / klavyedeki "Bitti" (enterkeyhint=done) = Yaziyi Ekle: satira bol/sigdir + kaydet + klavyeyi kapat.
      //  - "Yaziyi Ekle" liveText varken onu onaylar (ikinci kopya acmaz); yoksa eskisi gibi yeni yazi ekler.
      //  - Yazi kutusu secili yaziyi gosterir; secim kalkinca bosalir -> sonraki yazim yeni yazi acar.
      var liveText = null;
      function createText(c, txt) {
        // Faz 3.3: viewport-aware center (memory feedback_fabric_viewport_center)
        // left/top init etme — viewportCenterObject ile mobile vpt scale dogru hesaplanir
        var t = new window.fabric.IText(txt, {
          originX: 'center', originY: 'center',
          fontFamily: selectedFont, fontSize: 64, fontWeight: 700, fill: selectedColor,
          textAlign: selectedAlign,
          stroke: selectedStroke > 0 ? '#000000' : null,
          strokeWidth: selectedStroke,
          styles: {},
        });
        t._jkToolText = true;
        c.add(t);
        if (typeof c.viewportCenterObject === 'function') {
          c.viewportCenterObject(t);
        } else {
          var vpt = c.viewportTransform || [1,0,0,1,0,0];
          t.set({
            left: (c.width / 2 - vpt[4]) / vpt[0],
            top:  (c.height / 2 - vpt[5]) / vpt[3]
          });
        }
        t.setCoords();
        c.setActiveObject(t);
        c.requestRenderAll();
        t.on('editing:exited', function () { fitTextToPrint(c, t); });
        return t;
      }
      // Yazi onayi: satira bol/sigdir (+ okunurluk uyarisi), Geri al + taslak kaydi, klavyeyi kapat.
      function commitText(opts) {
        var c = window.JetAtolye && window.JetAtolye.canvas();
        var t = getActiveIText();
        if (c && t && !t.jkTplText) fitTextToPrint(c, t, { resetScale: t === liveText });
        if (c && t) fireModified(c, t);
        liveText = null;
        if (opts && opts.blur && input) input.blur();
      }

      // M5: Live preview — input'a her tuşta aktif IText'i güncelle
      if (input) {
        input.setAttribute('enterkeyhint', 'done');   // eski markup icin de (Liquid'de de var)
        input.setAttribute('autocomplete', 'off');
        input.addEventListener('input', function () {
          var t = getActiveIText();
          if (!t) {
            // #9: secili yazi yokken ilk tusta yeni yazi kanvasa eklenir (canli onizleme)
            if (!input.value.trim() || !window.fabric || !window.JetAtolye) return;
            var c0 = window.JetAtolye.canvas();
            if (!c0) return;
            liveText = createText(c0, input.value);
            fitTextToPrint(c0, liveText, { resetScale: true, silent: true, noHistory: true });
            return;
          }
          // Sablon v2: sablon yazisinda karakter siniri + en genis olcu korunur
          if (t.jkTplMaxChars && input.value.length > t.jkTplMaxChars) input.value = input.value.slice(0, t.jkTplMaxChars);
          if (t === liveText && !input.value) {
            // yazdigi her seyi silen musteri: bos yazi kanvasta kalmasin
            var c1 = window.JetAtolye.canvas();
            liveText = null;
            if (c1) { c1.remove(t); c1.discardActiveObject(); c1.requestRenderAll(); }
            return;
          }
          t.set('text', input.value);
          if (t.jkTplText) tplFitText(t);
          else if (t === liveText) fitTextToPrint(window.JetAtolye.canvas(), t, { resetScale: true, silent: true, noHistory: true });
          refreshActive();
        });
        input.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
          e.preventDefault();
          if (getActiveIText()) commitText({ blur: true });
          else if (addBtn && input.value.trim()) addBtn.click();
        });
        // Sablon v2: sablon yazisi secilince yazi kutusu o yaziyla dolar (bos kutuya yazinca tum yazi siliniyordu)
        // #9: artik her yazi icin (otomatik satir sonlari bosluk olarak gosterilir); secim kalkinca kutu bosalir.
        whenCanvas(function (c) {
          var fill = function () {
            var t = getActiveIText();
            if (t && t !== liveText) input.value = t.jkTplText ? (t.text || '') : String(t.text || '').replace(/\n/g, ' ');
            if (!t && liveText) liveText = null;
          };
          c.on('selection:created', fill);
          c.on('selection:updated', fill);
          c.on('selection:cleared', function () {
            if (liveText && document.activeElement === input) return;
            liveText = null;
            if (document.activeElement !== input) input.value = '';
          });
          c.on('text:changed', function (e) { if (e && e.target && e.target.jkTplText) tplFitText(e.target); });
          // Sablon v2: taslak/Geri al ile gelen yazi, web fontu henuz inmeden yedek fontla olculuyordu -> kutu genis,
          // yazi sola kayik basiliyordu (dogrula.js D6e: 400 -> 467 birim). Font inince yeniden olc (merkez sabit kalir).
          var remeasure = function (t) {
            if (!t || (t.type !== 'i-text' && t.type !== 'textbox' && t.type !== 'text')) return;
            var w0 = t.width;
            try { window.fabric.util.clearFabricFontCache(t.fontFamily); t.initDimensions(); } catch (e) { return; }
            if (t.jkTplText) tplFitText(t);
            // #10: yazi araciyla eklenen yazi gercek fontla genisleyince baski alanina yeniden sigdirilir (yalniz kucultur)
            else if (t._jkToolText && Math.abs((t.width || 0) - (w0 || 0)) > 0.5) fitTextToPrint(c, t, { silent: true, noHistory: true });
            if (Math.abs((t.width || 0) - (w0 || 0)) > 0.5) { t.setCoords(); c.requestRenderAll(); }
          };
          c.on('object:added', function (e) {
            var t = e && e.target;
            if (!t || !t.fontFamily || !document.fonts || !document.fonts.load) return;
            document.fonts.load((t.fontWeight || 400) + ' 40px "' + t.fontFamily + '"', t.text || 'Aa').then(function () { remeasure(t); }, function () {});
          });
          if (document.fonts && document.fonts.addEventListener) {
            document.fonts.addEventListener('loadingdone', function () { c.getObjects().forEach(remeasure); });
          }
        });
        input.addEventListener('change', function () {
          var t = getActiveIText();
          // #9/#10: Enter'a basmadan cikan musteri de satir bolme/sigdirma alir (kutudan duzenlenen mevcut yazi dahil)
          if (t && !t.jkTplText) { commitText(); return; }
          if (t) fireModified(window.JetAtolye.canvas(), t);
        });
        initTypingMode(input);
      }

      // Faz I-5: Font picker collapsible toggle
      var fontToggle = $('#jw-font-toggle');
      var fontToggleCurrent = $('#jw-font-toggle-current');
      var fontsGrid = $('#jw-fonts');
      if (fontToggle && fontsGrid) {
        fontToggle.addEventListener('click', function () {
          var open = fontToggle.getAttribute('aria-expanded') === 'true';
          fontToggle.setAttribute('aria-expanded', String(!open));
          fontsGrid.hidden = open;
        });
      }

      // Font seç
      fonts.forEach(function (b) {
        b.addEventListener('click', function () {
          fonts.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          selectedFont = b.dataset.font;
          // Faz I-5: Toggle button label + style update + grid kapat
          if (fontToggleCurrent) {
            var smallEl = b.querySelector('small');
            var displayName = smallEl ? smallEl.textContent.trim() : selectedFont;
            fontToggleCurrent.textContent = 'Aa ' + displayName;
            fontToggleCurrent.style.fontFamily = selectedFont;
          }
          if (fontToggle && fontsGrid) {
            fontToggle.setAttribute('aria-expanded', 'false');
            fontsGrid.hidden = true;
          }
          // M5: Google Font async load + apply
          var t = getActiveIText();
          if (window.document && document.fonts && document.fonts.load) {
            document.fonts.load('16px "' + selectedFont + '"').then(function () {
              if (t) {
                t.set('fontFamily', selectedFont);
                t.initDimensions();
                refreshActive();
                fireModified(window.JetAtolye.canvas(), t);
              }
            });
          } else if (t) {
            t.set('fontFamily', selectedFont);
            refreshActive();
          }
        });
      });

      // M5: Renk swatch
      swatches.forEach(function (s) {
        s.addEventListener('click', function () {
          swatches.forEach(function (x) { x.classList.remove('is-active'); });
          s.classList.add('is-active');
          selectedColor = s.dataset.color;
          if (picker) picker.value = selectedColor;
          var t = getActiveIText();
          if (t) { t.set('fill', selectedColor); refreshActive(); fireModified(window.JetAtolye.canvas(), t); }
        });
      });
      // M5: Native renk picker
      if (picker) {
        picker.addEventListener('input', function () {
          selectedColor = picker.value;
          // Custom renk olunca hiçbir swatch active değil (görünür custom)
          swatches.forEach(function (x) { x.classList.remove('is-active'); });
          var t = getActiveIText();
          if (t) { t.set('fill', selectedColor); refreshActive(); }
        });
        picker.addEventListener('change', function () {
          var t = getActiveIText();
          if (t) fireModified(window.JetAtolye.canvas(), t);
        });
      }

      // M5: Hizalama
      aligns.forEach(function (a) {
        a.addEventListener('click', function () {
          aligns.forEach(function (x) { x.classList.remove('is-active'); });
          a.classList.add('is-active');
          selectedAlign = a.dataset.align;
          var t = getActiveIText();
          if (t) { t.set('textAlign', selectedAlign); refreshActive(); fireModified(window.JetAtolye.canvas(), t); }
        });
      });

      // M5: Stroke slider
      if (strokeSlider) {
        strokeSlider.addEventListener('input', function () {
          selectedStroke = parseInt(strokeSlider.value, 10) || 0;
          if (strokeVal) strokeVal.textContent = selectedStroke;
          var t = getActiveIText();
          if (t) {
            t.set('strokeWidth', selectedStroke);
            t.set('stroke', selectedStroke > 0 ? '#000000' : null);
            refreshActive();
          }
        });
        strokeSlider.addEventListener('change', function () {
          var t = getActiveIText();
          if (t) fireModified(window.JetAtolye.canvas(), t);
        });
      }

      // C4/K6 (2026-09-30, METIN PAKETI): uzun yazi baski alanindan tasiyordu. Ekleme sonrasi + duzenlemeden
      // cikista (text:changed DEGIL — her tusta kucultur) baski genisliginin %92'sine sigdirilir; bildirim nesne basina 1 kez.
      // #10 (2026-10-03): kucultmeden ONCE kelime sinirinda 2-3 satira bolunur (yalniz otomatik satir sonu; musterinin
      // kendi satir sonlarina dokunulmaz). Sigdirma sonrasi baskidaki yazi boyu ~3 mm'nin altindaysa TEK uyari
      // (eski "kucultuldu" bildirimi bununla birlesti). Olcek: baski genisligi ~7,5 cm = 490 kanvas birimi
      // (PRINT.w; bkz. bu dosyada foto DPI hesabi "Kilif baski genisligi ~7,5 cm = 490 kanvas birimi")
      // -> 1 birim ~ 0,153 mm; yazi boyu = fontSize x olcek (05-atolye-gelistirme.md #10 ile ayni olcu).
      var MM_PER_UNIT = 75 / 490;
      var MIN_TEXT_MM = 3;
      function wrapCandidates(raw, n) {
        // kelime sinirinda n satira bol: en uzun satiri (karakter) en kisa yapan bolme
        var words = raw.split(/\s+/).filter(Boolean);
        if (n <= 1 || words.length < n) return null;
        var best = null, bestMax = Infinity;
        var lens = words.map(function (w) { return w.length; });
        var lineLen = function (a, b) { var s = 0; for (var i = a; i < b; i++) s += lens[i]; return s + (b - a - 1); };
        if (n === 2) {
          for (var i = 1; i < words.length; i++) {
            var m2 = Math.max(lineLen(0, i), lineLen(i, words.length));
            if (m2 < bestMax) { bestMax = m2; best = [words.slice(0, i), words.slice(i)]; }
          }
        } else {
          for (var a = 1; a < words.length - 1; a++) {
            for (var b = a + 1; b < words.length; b++) {
              var m3 = Math.max(lineLen(0, a), lineLen(a, b), lineLen(b, words.length));
              if (m3 < bestMax) { bestMax = m3; best = [words.slice(0, a), words.slice(a, b), words.slice(b)]; }
            }
          }
        }
        return best ? best.map(function (l) { return l.join(' '); }).join('\n') : null;
      }
      function fitTextToPrint(c, t, opts) {
        opts = opts || {};
        if (!c || !t || t.jkTplText) return;
        var PA = window.JetAtolye.getPrintBounds && window.JetAtolye.getPrintBounds();
        if (!PA || !PA.w) return;
        var maxW = PA.w * 0.92;
        if (opts.resetScale) t.set({ scaleX: 1, scaleY: 1 });
        // Otomatik bolunmus yazi her seferinde tek satirdan yeniden degerlendirilir (kisalinca satirlar geri birlesir)
        var userBreaks = /\n/.test(t.text || '') && !t.jkAutoWrap;
        if (!userBreaks) {
          var raw = String(t.text || '').replace(/\s*\n\s*/g, ' ');
          var chosen = raw;
          var widthOf = function (s) { t.set('text', s); t.initDimensions(); return t.width * t.scaleX; };
          if (widthOf(raw) > maxW) {
            var bestS = raw, bestW = t.width * t.scaleX;
            for (var n = 2; n <= 3; n++) {
              var cand = wrapCandidates(raw, n);
              if (!cand) break;
              var w = widthOf(cand);
              if (w < bestW) { bestW = w; bestS = cand; }
              if (w <= maxW) break;
            }
            chosen = bestS;
          }
          t.set('text', chosen);
          t.initDimensions();
          t.jkAutoWrap = chosen !== raw;
        }
        t.setCoords();
        var sw = t.getScaledWidth();
        var changed = false;
        if (sw > maxW) { t.scale(t.scaleX * maxW / sw); changed = true; }
        t.setCoords(); c.requestRenderAll();
        if ((changed || t.jkAutoWrap) && !opts.noHistory) c.fire('object:modified', { target: t });
        if (opts.silent) return;
        var mm = (t.fontSize || 0) * (t.scaleY || 1) * MM_PER_UNIT;
        if (mm < MIN_TEXT_MM && !t._jkFitWarned) {
          t._jkFitWarned = true;
          window.JetAtolye.notify('Bu yazı baskıda okunmayacak kadar küçük olabilir — kısaltmanı ya da satıra bölmeni öneririz.', 'warning', { duration: 6000 });
        }
      }

      // Yazı Ekle (yeni IText oluştur) — #9: yazarken eklenmis yazi varsa onu onaylar (ikinci kopya acmaz)
      if (addBtn) addBtn.addEventListener('click', function () {
        // Dugmeye basmak once yazi kutusunu birakir ('change' -> commitText, liveText=null). Kanvasta zaten kutudaki
        // yaziyla ayni secili yazi varsa yalniz onayla — ikinci kopya acma (cogaltmak icin araç cubugunda Çoğalt var).
        var act = getActiveIText();
        var val = (input && input.value || '').trim();
        if (act && !act.jkTplText && (act === liveText || (val && String(act.text || '').replace(/\s*\n\s*/g, ' ').trim() === val))) {
          commitText({ blur: true });
          return;
        }
        var txt = (input && input.value || '').trim() || 'BURAYA YAZINI YAZ';
        if (!window.fabric || !window.JetAtolye) return;
        var c = window.JetAtolye.canvas();
        var addText = function () {
          var t = createText(c, txt);
          fitTextToPrint(c, t);
        };
        // M5: Font yüklenmesini bekle (display=swap fallback ile çakışma önle)
        if (document.fonts && document.fonts.load) {
          document.fonts.load('16px "' + selectedFont + '"').then(addText).catch(addText);
        } else {
          addText();
        }
      });
    }

    // #9 (2026-10-03): klavye acikken (mobil) Yazi sayfasi kompakt olur — yalniz yazi kutusu + "Yazıyı Ekle" kalir,
    // sayfa visualViewport'un altina oturur (iOS'ta klavyenin hemen ustu), tasarim gorunur alana sigacak kadar kuculur.
    // Klavye kapaninca (blur) her sey eski haline doner. Masaustunde calismaz.
    function initTypingMode(input) {
      var mq = window.matchMedia('(max-width: 749px)');
      var vv = window.visualViewport;
      var on = false;
      function sheetEl() { return document.getElementById('jw-sheet'); }
      function layoutTyping() {
        var sheet = sheetEl();
        if (!on || !sheet) return;
        var vh = vv ? vv.height : window.innerHeight;
        var top = vv ? vv.offsetTop : 0;
        // fixed bottom:0 iOS'ta klavyenin arkasinda kalir -> gorunur alanin altina tasi
        sheet.style.bottom = Math.max(0, Math.round(window.innerHeight - (top + vh))) + 'px';
        var dev = document.getElementById('jw-device');
        if (dev && dev.offsetHeight) {
          // transform-origin: top center -> ust kenar yerinde kalir; olcek, ust kenardan sayfanin ustune kadar
          // olan alana gore (offsetHeight transform'dan etkilenmez, gecis animasyonu olcumu bozmaz)
          var sh = sheet.offsetHeight || 0;
          var devTop = dev.getBoundingClientRect().top - top;
          var avail = (vh - sh) - devTop - 8;
          var s = Math.max(0.3, Math.min(1, avail / dev.offsetHeight));
          dev.style.transform = 'scale(' + s.toFixed(3) + ')';
        }
      }
      function enter() {
        if (!mq.matches) return;
        var sheet = sheetEl();
        if (!sheet || !sheet.contains(input)) return;
        on = true;
        sheet.classList.add('is-typing');
        document.body.classList.add('jw--typing');
        layoutTyping();
        setTimeout(layoutTyping, 350);   // klavye animasyonu sonrasi
      }
      function leave() {
        if (!on) return;
        on = false;
        var sheet = sheetEl();
        if (sheet) { sheet.classList.remove('is-typing'); sheet.style.bottom = ''; }
        document.body.classList.remove('jw--typing');
        var dev = document.getElementById('jw-device');
        if (dev) dev.style.transform = '';
        // Yuzen arac cubugu kucuk kanvasa gore konumlanmisti -> olcek gecisi (0.3 sn) bitince yeniden konumlansin
        setTimeout(function () {
          var c = window.JetAtolye && window.JetAtolye.canvas && window.JetAtolye.canvas();
          var a = c && c.getActiveObject();
          if (a && !on) { try { c.fire('selection:updated', { selected: [a], deselected: [], target: a }); } catch (e) {} }
        }, 340);
      }
      input.addEventListener('focus', enter);
      input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) leave(); }, 0); });
      if (vv) { vv.addEventListener('resize', layoutTyping); vv.addEventListener('scroll', layoutTyping); }
      window.addEventListener('resize', layoutTyping);
    }

    // ------------------------------------------------------------------
    // Bus event bindings (mevcut sistem -> wizard UI guncelleme)
    function initBusBindings() {
      if (!window.JetAtolye || !window.JetAtolye.bus) return;
      var bus = window.JetAtolye.bus;
      bus.on && bus.on('model-change', function (m) {
        var brand = $('#jw-brand');
        var model = $('#jw-model');
        if (brand && m && m.brand) brand.value = m.brand;
        if (model && m && m.slug) model.value = m.slug;
      });
      // 2026-10-03: modele ozel teknik not (or. iPhone 18 Pro lens koruyucu) — slug basina 1 kez
      var _notedSlugs = {};
      bus.on && bus.on('model-change', function (m) {
        var note = m && m.slug && window.JET_FRAME && window.JET_FRAME.getNote && window.JET_FRAME.getNote(m.slug);
        if (!note || _notedSlugs[m.slug]) return;
        _notedSlugs[m.slug] = true;
        if (window.JetAtolye && window.JetAtolye.notify) window.JetAtolye.notify('Teknik not: ' + note, 'info', { duration: 9000 });
      });
    }

    // ------------------------------------------------------------------
    // #16 (2026-10-03): Sepete Ekle dugmesinde fiyat. Kaynak: secili kilif tipinin urun JSON'u (/products/<handle>.js),
    // secili varyant (JetWizardGetVariantId) -> price / compare_at_price. Ilk an icin Liquid'in data-products fiyati.
    // Hedef: sections/jet-atolye-shell.liquid .ja-shell__atc-price (yoksa hicbir sey yapmaz).
    // #15c: sepette TEK kilif varken guven seridinde "2. kılıf %25 indirimli" (sections/jet-atolye-wizard.liquid .ja-trust__offer).
    // Oran kaynagi: Shopify otomatik indirim "İkinci Kılıf %25 İndirim" (BXGY: 1 al -> 1 tanesi %25, koleksiyon
    // kisisel-kilif + jk-studio, siparis basina sinirsiz; Admin API automaticDiscountNodes, 2026-10-03 okundu).
    // Indirim degisirse bu metin ve Liquid'deki metin elle guncellenmeli.
    function initPriceAndOffer() {
      var data = {};
      try { data = JSON.parse(root.dataset.products || '{}'); } catch (e) {}
      var handles = Object.keys(data).map(function (k) { return data[k] && data[k].handle; }).filter(Boolean);
      var cache = {};
      var esc = function (s) { return String(s).replace(/[&<>"']/g, ''); };
      function fmt(cents) {
        var c = Math.round(Number(cents) || 0);
        return (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' TL';
      }
      function productJson(handle) {
        if (!cache[handle]) {
          cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        }
        return cache[handle];
      }
      function currentKey() {
        var js = window.JetAtolye && window.JetAtolye.state;
        var k = (js && js.productKey) || state.productKey;
        if (k && data[k]) return k;
        for (var x in data) { if (data[x] && data[x].default) return x; }
        return Object.keys(data)[0];
      }
      function renderPrice() {
        var el = document.querySelector('.ja-shell__atc-price');
        var key = currentKey();
        var p = key && data[key];
        if (!el || !p) return;
        if (!el.textContent && p.price) { el.textContent = p.price; el.hidden = false; }
        productJson(p.handle).then(function (pj) {
          if (!pj || !pj.variants) return;
          var vid = (typeof window.JetWizardGetVariantId === 'function') && window.JetWizardGetVariantId();
          var v = null;
          pj.variants.forEach(function (x) { if (String(x.id) === String(vid)) v = x; });
          var price = v ? v.price : pj.price;
          var cmp = v ? v.compare_at_price : pj.compare_at_price;
          if (currentKey() !== key) return;   // istek sirasinda tip degisti
          el.innerHTML = (cmp && cmp > price ? '<s>' + esc(fmt(cmp)) + '</s> ' : '') + esc(fmt(price));
          el.hidden = false;
        });
      }
      function cartCases(cart) {
        return ((cart && cart.items) || []).reduce(function (n, it) {
          // Kilif = atolye urunu ya da model varyantli urun (hazir tasarimlar da BXGY koleksiyonunda; snippets/jet-cart-bump ile ayni olcut)
          var isCase = handles.indexOf(it.handle) !== -1 || !!(it.properties && it.properties['Telefon Modeli'])
            || !!(it.variant_title && it.variant_title !== 'Default Title');
          return n + (isCase ? (it.quantity || 0) : 0);
        }, 0);
      }
      var offerReq = 0;
      function refreshOffer() {
        var trust = document.getElementById('ja-trust');
        var offer = trust && trust.querySelector('.ja-trust__offer');
        if (!offer) return;
        var my = ++offerReq;
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
          if (!cart || my !== offerReq) return;
          var show = cartCases(cart) === 1;
          offer.hidden = !show;
          trust.classList.toggle('has-offer', show);
        }).catch(function () {});
      }
      renderPrice();
      refreshOffer();
      var bus = window.JetAtolye && window.JetAtolye.bus;
      if (bus && bus.on) {
        bus.on('model-change', renderPrice);
        bus.on('product-change', renderPrice);
      }
      // varyant haritasi gec inerse fiyat varyanttan yeniden okunur
      setTimeout(renderPrice, 2500);
      document.addEventListener('cart:refresh', function () { setTimeout(refreshOffer, 300); });
      document.addEventListener('jet:upload-complete', function () { setTimeout(refreshOffer, 600); });
      window.JetWizardRefreshOffer = refreshOffer;
    }

    // Faz 1.3+1.4: Ortak modal CSS injection (idempotent). Hem resume draft hem
    // Faz 1.4 model degistir modal'i ayni stili paylasir.
    function ensureModalStyle() {
      if (document.getElementById('jw-resume-modal-style')) return;
      var st = document.createElement('style');
      st.id = 'jw-resume-modal-style';
      st.textContent = '\
.jw-resume-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;font-family:inherit}\
.jw-resume-modal__backdrop{position:absolute;inset:0;background:rgba(26,26,26,.55)}\
.jw-resume-modal__panel{position:relative;background:#FAF5EE;border-radius:16px;padding:1.75rem 1.5rem;max-width:380px;width:calc(100% - 2rem);box-shadow:0 8px 32px rgba(0,0,0,.18);animation:jwResumeIn .25s ease-out}\
.jw-resume-modal__title{font-size:1.15rem;font-weight:700;color:#1A1A1A;margin:0 0 .65rem;line-height:1.3}\
.jw-resume-modal__body{font-size:.92rem;line-height:1.5;color:#4A4A4A;margin:0 0 1.25rem}\
.jw-resume-modal__time{font-weight:600;color:#1A1A1A}\
.jw-resume-modal__actions{display:flex;gap:.6rem;justify-content:flex-end;flex-wrap:wrap}\
.jw-resume-modal__btn{font-size:.88rem;font-weight:600;padding:.65rem 1.1rem;border-radius:10px;cursor:pointer;border:none;font-family:inherit;transition:transform .15s,opacity .15s}\
.jw-resume-modal__btn--primary{background:#FF6B5D;color:#fff}\
.jw-resume-modal__btn--ghost{background:transparent;color:#4A4A4A;border:1px solid rgba(0,0,0,.15)}\
.jw-resume-modal__btn:hover{transform:translateY(-1px);opacity:.92}\
.jw-resume-modal__btn:focus-visible{outline:2px solid #FF6B5D;outline-offset:2px}\
@keyframes jwResumeIn{from{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}\
@media (prefers-reduced-motion:reduce){.jw-resume-modal__panel{animation:none}}';
      document.head.appendChild(st);
    }

    // Faz 1.4: Model degistirme onay modali — kullanici tasarim yaptiysa uyar.
    // cb(true) -> setModel cagir; cb(false) -> dropdown eski degere geri al.
    function showModelChangeConfirm(newModelName, cb) {
      ensureModalStyle();
      var modal = document.createElement('div');
      modal.className = 'jw-resume-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'jw-model-change-title');
      modal.innerHTML = '<div class="jw-resume-modal__backdrop"></div>'
        + '<div class="jw-resume-modal__panel">'
        + '  <h2 class="jw-resume-modal__title" id="jw-model-change-title">Modeli degistir?</h2>'
        // A9 (2026-09-25): eski metin "pozisyon otomatik ayarlanir" diyordu, fonksiyon bos (clampToPa no-op)
        + '  <p class="jw-resume-modal__body"><strong>' + String(newModelName || 'Yeni model').replace(/[&<>"']/g, '')
        + '</strong> modeline geçince tasarımın yerinde kalır, yeni kılıfın kesimine göre kırpılır. Kenarları kontrol etmeyi unutma. Devam edilsin mi?</p>'
        + '  <div class="jw-resume-modal__actions">'
        + '    <button type="button" class="jw-resume-modal__btn jw-resume-modal__btn--ghost" data-action="cancel">Iptal</button>'
        + '    <button type="button" class="jw-resume-modal__btn jw-resume-modal__btn--primary" data-action="confirm" autofocus>Devam et</button>'
        + '  </div>'
        + '</div>';
      function close(result) {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
        document.removeEventListener('keydown', onKey);
        try { cb(result); } catch (e) {}
      }
      function onKey(e) { if (e.key === 'Escape') close(false); }
      modal.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.dataset && t.dataset.action === 'confirm') close(true);
        else if (t && t.dataset && t.dataset.action === 'cancel') close(false);
      });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(modal);
      var primary = modal.querySelector('[data-action="confirm"]');
      if (primary && primary.focus) primary.focus();
    }
  }
})();

// B7 (2026-09-24): 'case-type-reset' dinleyicisi (F4) kaldirildi — bu event hicbir yerde yayinlanmiyordu.
// Model secilince Kilif Tipi adimi zaten aciliyor (desktop openStep(3), mobil sheet zinciri).
